import { Avatar, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import { fabric } from "fabric";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CadisDialog from "../../Components/Dialog/CadisDialog";
import { useTimer } from "../../Hooks/useTimerHook";
import { useSocketContext } from "../../context/SocketContext";
// ICONS
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CenterFocusWeakIcon from "@mui/icons-material/CenterFocusWeak";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CropSquareRoundedIcon from "@mui/icons-material/CropSquareRounded";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import MicOffIcon from '@mui/icons-material/MicOff';
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import StopIcon from "@mui/icons-material/Stop";
import TitleSharpIcon from "@mui/icons-material/TitleSharp";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import PersonIcon from "@mui/icons-material/Person";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import { SubscriptionDataUsage, GetVirtualBackgroundsRoute, UploadVirtualBackgroundRoute, ClearVirtualBackgroundSelectionRoute, BlurVirtualBackgroundSelectionRoute, SelectVirtualBackgroundRoute, DeleteVirtualBackgroundRoute, VirtualBackgroundImageRoute } from "../../Common/api.routes";
import { AST_LEAVE_CONFERENCE_CALL, CALL_END_BY_ASSISTANT, CALL_USER_LEFT, CLEAR_SCREEN, CONFERENCE_CALL_REJECTED, DRAW_FREEHAND, DRAW_OBJECT, DRAW_TEXT, END_CALL, ON_OFF_AUDIO, RECORDING_ENDED, RECORDING_STARTED, REMOVE_OBJECT, REMOVE_TEXT, ROKID_CURRENT_RESOLUTION, ROKID_MAIN_VIEW, ROOM_DESTROYED, SET_WEB_AST_NAME, WAST_MAIN_VIEW, WEB_AST_LEAVE_CALL } from "../../Common/helper";
import { coordsTransformRatio, isAuthenticated, } from "../../Common/helperFunction";
import CadisButton from "../../Components/Input/CadisButton";
import preventBackNavigation from "../../Components/NavigationBackDialog/PreventBackNavigation";
import apis from "../../HttpConfig/Api";
import DataExhaustedDialog from "./DataLimitPopup";
import ToggleComponent from "./ToggleComponent";
import VIRTUAL_BACKGROUNDS from "./virtualBackgrounds";
import logger from "../../logger/BatchedLogger";

// ====== Agora variables ======
var agoraClient = null;
var localAudioTrackAgora = null;
var localVideoTrackAgora = null;
var remoteUsers = {};  // uid -> IAgoraRTCRemoteUser
var participantRoles = {}; // uid -> 'webassistant' | 'rokid' | 'consultant'
var agoraReconnectTimer = null;
var isManuallyReconnecting = false;  // prevents duplicate concurrent manual reconnect attempts
var networkQualityDownlinkLevel = 0; // 0=unknown, 1=excellent ... 6=disconnected

// Deterministic Agora UIDs per role
var AGORA_UID_CONSULTANT = 1;
var AGORA_UID_WEBASSISTANT = 2;
var AGORA_UID_ROKID = 3;

var isRokidOnMain = true;
var isRokidOnMainInConf = false;

// ====== Virtual background (Agora extension) variables ======
var virtualBgExtension = null;   // singleton VirtualBackgroundExtension (registered once)
var virtualBgProcessor = null;   // VirtualBackgroundProcessor piped into the local camera track
var virtualBgPiped = false;      // whether the processor is currently piped into the track

let bitrateTimeout;
var canvas;
let arr_coords = [];
let vWidth;
let vHeight;

// recording variables
let mediaRecorder;
let chunks = [];
let recordMainView = true;

// zoom variable
let zoomLevel = 100;
// annotattion variables
let drawnRect = false;
let drawnCircle = false;

//data consumption variables
let prevBytesSent = 0;
var webassistantIntervalId = null;
var rokidIntervalId = null;
var dataSent = 0;
var wastDataReceived = 0;
var rokidDataReceived = 0;
var conIntervalDataSent = 0;
var wastIntervalDataSent = 0;
var rokidIntervalDataSent = 0;
var intervalId = 0;
var isRunning = sessionStorage.setItem("isRunning", JSON.stringify(true));

function useEventListener(socketRef, eventName, callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    const eventHandler = (data) => {
      callbackRef.current(data);
    };
    socketRef.current?.on(eventName, eventHandler);

    return () => {
      socketRef.current?.off(eventName, eventHandler);
      sessionStorage.removeItem("userTyping")
    };
  }, [socketRef, eventName]);

  // Update the callback if it changes
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  return callbackRef;
}

const CallScreen = () => {
  const { socketRef, failedPong, callToAssistantRef, roomDetails, sessionIdRef, isConferenceCall, isNormalCall, isMuteRokid, isWebAsstMuted, wastInviteSent, rokidInviteSent, isWAConferenceCallRef, callJoinToneRef, setRoomDetails, setInCommingCall, setInviteDialog, setSelfEmailAddress, setAgoraConfig, setCallToAssistant, setUserDetails, openInviteDialog, openReconnectDialog, setIsConferenceCall, setRokidInviteDialog, openRokidUserInviteDialog, setEmailAddress, SetIsMuteRokid, SetIsWebAsstMuted, setWastInviteSent, setRokidInviteSent } = useSocketContext();
  const { seconds, minutes, hours, handleStart, handleReset } = useTimer(); // timer customeHook
  const navigate = useNavigate();
  const { state } = useLocation();
  const isRecording = sessionStorage.getItem("isRecording") === "true";
  const isWebAstJoinCheck = sessionStorage.getItem("isWebAssistantJoin") === "true";
  const { navigationBackPopup, setNavigationBackPopup } = preventBackNavigation('/dashboard/assistants');
  // refs for glass video referense
  const remoteVideoRef1 = useRef();
  const remoteVideoRef2 = useRef();
  const remoteAudioRef1 = useRef();
  const remoteAudioRef2 = useRef();
  const localVideoRef = useRef();
  const canvasTxtRef = useRef();
  const isLeavingCallRef = useRef(false);    // set true before cleanupAgora to block reconnect effects
  const isJoiningRef = useRef(false);         // mutex: prevents concurrent Agora join calls (Bug 1)
  const lastJoinedTokenRef = useRef(null);    // tracks the last token used for Agora join (Bug 1 & 4)
  const [notes, setNotes] = useState("");
  const [isRemoteVideo, setIsRemoteVideo] = useState(false);
  // True when the web assistant (UID 2) has turned their camera off while still in the call —
  // show an avatar over their feed instead of a frozen/blank video.
  const [isWebAstCameraOff, setIsWebAstCameraOff] = useState(false);
  // True when the consultant has turned their OWN camera off — show an avatar over the self-view.
  const [isConsultantCameraOff, setIsConsultantCameraOff] = useState(false);
  const [isPluginAttached, setIsPluginAttached] = useState(false);
  const [annotate, setAnnotate] = useState(false);
  const [recording, setRecording] = useState(isRecording);
  const [takeNotes, setTakeNotes] = useState(false);
  const [takeMessage, setTakeMessage] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState('');
  const [remoteAudioTrack, setRemoteAudioTrack] = useState();
  const [localAudioTrack, setLocalAudioTrack] = useState();
  const [isSend, setIsSend] = useState(false);
  const [userLeftAlert, setUserLeftAlert] = useState(false);
  const [isButtonSelected, setIsButtonSelected] = useState('');
  const [isRokidAstJoin, setIsRokidAstJoin] = useState(false);
  const [isWebAstJoin, setIsWebAstJoin] = useState(isWebAstJoinCheck);
  // Name the web assistant entered when joining — shown at the top-middle of the call screen.
  const [webAstName, setWebAstName] = useState(sessionStorage.getItem("webAssitName") || "");
  const [container1, setContainer1] = useState('container1');
  const [container2, setContainer2] = useState('container2');
  const [isMainView, setIsMainView] = useState(true);
  const [showAnnotateBtn, setShowAnnotateBtn] = useState(false);
  const [showMuteIcon, setShowMuteIcon] = useState(false);
  const [recordingPopup, setRecordingPopup] = useState(false);
  const [consAudio, setConsAudio] = useState(null);
  const [recordingSession, setRecordingSession] = useState(sessionStorage.getItem("isRecording") === "true");
  const [dataUsageTimer, setDataUsageTimer] = useState(0);
  const [dataExhausted, setDataExhausted] = useState(false);
  const [showDataExhausted, setShowDataExhausted] = useState(true);
  const [remainingDataPercentage, setRemainingDataPercentage] = useState("");
  const [showDataText, setShowDataText] = useState(false);
  const [textAnnotationError, setTextAnnotationError] = useState(false);
  const [virtualBg, setVirtualBg] = useState("none");            // currently APPLIED background id
  const [bgDialogOpen, setBgDialogOpen] = useState(false);       // background picker dialog open?
  const [pendingBg, setPendingBg] = useState("none");            // highlighted-but-not-yet-applied selection
  const [applyingBg, setApplyingBg] = useState(false);           // Apply button busy state
  const virtualBgRef = useRef("none");                           // latest applied selection, read by (re)connect flows
  const [defaultBgs, setDefaultBgs] = useState([]);              // system/default backgrounds from the API
  const [myBgs, setMyBgs] = useState([]);                        // current user's uploaded backgrounds
  const [bgsLoading, setBgsLoading] = useState(false);           // fetch-in-progress flag for the dialog
  const [uploadingBg, setUploadingBg] = useState(false);         // upload-in-progress flag
  const [deletingBgId, setDeletingBgId] = useState(null);        // id currently being deleted (or null)
  const allBgOptionsRef = useRef([{ id: "none", type: "none" }, { id: "blur", type: "blur", blurDegree: 2 }]); // flat lookup list used by applyVirtualBackground
  const bgFileInputRef = useRef(null);                           // hidden <input type="file"> for uploads
  const user = isAuthenticated();
  const { t } = useTranslation();
  let isDrawing = false;

  // const containerRef = useRef();

  const handleWebAstLeaveCall = (data) => {
    toast.info(`${data} has left the call.`);
    setIsWebAstJoin(false);
    sessionStorage.setItem("isWebAssistantJoin", JSON.stringify(false));
    sessionStorage.removeItem("webAssitName");
    setWebAstName("");
    SetIsWebAsstMuted(false);
    if (recording && isMainView) {
      handleStopRecording();
      sessionStorage.setItem("isRecording", JSON.stringify(false));
      setRecording(false);
      sessionStorage.setItem("isRecording", JSON.stringify(false));
      setRecording(false);
      setRecordingSession(false);
    }
    setTakeMessage(false);
  };

  const handleRokidAstLeaveCall = (data) => {
    toast.info(data + ' has left the call.');
    canvas?.clear();
    setNotes('');
    setTakeNotes(false);
    setSelectedIcon('');
    setIsRokidAstJoin(false);
    setAnnotate(false);
    SetIsMuteRokid(false);
    sessionStorage.setItem("isRokidAstJoin", JSON.stringify(false));
    // if (!isMainView) {
    //   setRecordingPopup(false);
    // }
    if (recording && !isMainView) {
      handleStopRecording();
      sessionStorage.setItem("isRecording", JSON.stringify(false));
      setRecording(false);
      sessionStorage.setItem("isRecording", JSON.stringify(false));
      setRecording(false);
      setRecordingSession(false);
    }
  };

  const handleRokidRejectedCall = (data) => {
    toast.info(data + ' has rejected the call.');
    setIsRokidAstJoin(false)
  };

  const webAstLeaveCallCallbackRef = useEventListener(socketRef, WEB_AST_LEAVE_CALL, handleWebAstLeaveCall);
  const rokidAstLeaveCallCallbackRef = useEventListener(socketRef, AST_LEAVE_CONFERENCE_CALL, handleRokidAstLeaveCall);
  const rokidRejectedConferenceCall = useEventListener(socketRef, CONFERENCE_CALL_REJECTED, handleRokidRejectedCall);

  useEffect(() => {

    // socket event on if glass user end call
    socketRef.current?.on(ROOM_DESTROYED, async () => {
      if (mediaRecorder?.state === "recording") {
        mediaRecorder?.stop();
      }
      isLeavingCallRef.current = true;
      await cleanupAgora();
      handleReset();
      navigate("/callquality");
    });

    //Changed event from ROOM_DESTROYED to CALL_END_BY_ASSISTANT socket event if glass user end call
    socketRef.current?.on(CALL_END_BY_ASSISTANT, async (data) => {
      if (recording) {
        handleStopRecording()
      }
      isLeavingCallRef.current = true;
      await cleanupAgora();
      handleReset();
      toast.info(data + " has ended the call.")
      navigate("/callquality");
      SetIsMuteRokid(false);
    });

    socketRef.current?.on(CALL_USER_LEFT, () => {
      canvas.clear();
      handleStopRecording();
      setRecording(false);
      setUserLeftAlert(true);
      setIsRemoteVideo(false);
    })

    socketRef.current?.on(ROKID_CURRENT_RESOLUTION, (data) => {
      sessionStorage.setItem("rokidWidth", JSON.stringify(data.width));
      sessionStorage.setItem("rokidHeight", JSON.stringify(data.height));
    });

    // Web assistant's entered name — surface it in React state so the top-middle label updates live.
    socketRef.current?.on(SET_WEB_AST_NAME, (data) => {
      if (data) {
        sessionStorage.setItem("webAssitName", data);
        setWebAstName(data);
      }
    });

    const username = JSON.parse(sessionStorage.getItem('username'));
    let userRole = parseInt(JSON.parse(sessionStorage.getItem('role')));
    setUserDetails({ username: username, userrole: userRole });
    if (!socketRef.current && (userRole === 3) && apis.socketURL) {
      socketRef.current = io(apis.socketURL, { transports: ['websocket'] });
    }
    const conferenceCallStarted = sessionStorage.getItem("isConferenceCall") === "true"
    if (conferenceCallStarted) {
      isRokidOnMainInConf = false;
      isRokidOnMain = false;
    }

    return () => {
      setInCommingCall(false);
      setRoomDetails(null);
      setAgoraConfig(null);
      setCallToAssistant({ 'open': false, 'UserID': null, 'AssistantName': '' });
      zoomLevel = 100;
      callToAssistantRef.current = { open: false, UserID: null, AssistantName: '' };
      socketRef.current?.off(ROOM_DESTROYED);
      socketRef.current?.off(CALL_END_BY_ASSISTANT);
      socketRef.current?.off(CALL_USER_LEFT);
      socketRef.current?.off(WEB_AST_LEAVE_CALL)
      socketRef.current?.off(CONFERENCE_CALL_REJECTED)
      handleStopRecording();
      clearTimeout(bitrateTimeout);
      bitrateTimeout = null;
      // Clean up Agora resources on unmount
      isLeavingCallRef.current = true;
      cleanupAgora();
      canvas.clear();
      canvasTxtRef.current = null;
    };
  }, [socketRef.current]);

  useEffect(() => {
    // set runtime W and H to canvas
    let pvideo_container = document.querySelector('#container1');
    if (pvideo_container && pvideo_container.getBoundingClientRect) {
      vWidth = pvideo_container.getBoundingClientRect().width;
      vHeight = pvideo_container.getBoundingClientRect().height;
    }
    // fabric canvas
    canvas = new fabric.Canvas("canvas", {
      width: vWidth,
      height: vHeight,
    });

    // when user move any object on canvas --> func runs
    canvas.on({
      "object:modified": function (e) {
        let active_shape = canvas.getActiveObject();
        let acoords = active_shape.aCoords;
        let type = e.target.get("type");
        const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
        const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
        let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
        if (type === "circle") {
          socketRef.current.emit(DRAW_OBJECT, {
            webAssistantViewFlag,
            type,
            coords: {
              tl: {
                x: acoords.tl.x * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
                y: acoords.tl.y * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
              },
              tr: { x: acoords.tr.x, y: acoords.tr.y },
              bl: { x: acoords.bl.x, y: acoords.bl.y },
              br: { x: acoords.br.x, y: acoords.br.y },
            },
            dimensions: {
              w: active_shape.radius * e.target.scaleX * 2 * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
              h: active_shape.radius * e.target.scaleY * 2 * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
            },
            sessionId: sessionIdRef.current
          });
        } else if (type === "rect") {
          socketRef.current.emit(DRAW_OBJECT, {
            webAssistantViewFlag,
            type,
            coords: {
              tl: {
                x: acoords.tl.x * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
                y: acoords.tl.y * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
              },
              tr: { x: acoords.tr.x, y: acoords.tr.y },
              bl: { x: acoords.bl.x, y: acoords.bl.y },
              br: { x: acoords.br.x, y: acoords.br.y },
            },
            dimensions: {
              w: active_shape.width * e.target.scaleX * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
              h: active_shape.height * e.target.scaleY * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
            },
            sessionId: sessionIdRef.current
          });
        }
      },
    });

  }, []);

  const handleResizeCanvas = () => {
    let pvideo_container = document.querySelector('#container1');
    if (pvideo_container && pvideo_container.getBoundingClientRect) {
      vWidth = pvideo_container.getBoundingClientRect().width;
      vHeight = pvideo_container.getBoundingClientRect().height;
    }
    canvas.setDimensions({ width: vWidth, height: vHeight });
    setTimeout(() => {
      if ((sessionStorage.getItem("userTyping") !== "true") && (sessionStorage.getItem("userTyping") !== "textSend")) {
        canvas?.clear();
        socketRef.current?.emit(CLEAR_SCREEN, sessionIdRef.current);
        setNotes('');
        setTakeNotes(false);
        setSelectedIcon('');
      }
    }, 500);
  }

  // by Deepika
  const containerRef = useRef(null);
  const innerContainerRef = useRef(null);

  const maintainAspectRatio = () => {
    const videoContainer = containerRef.current;
    const innerContainer = innerContainerRef.current;
    if (!videoContainer || !innerContainer) return;

    const containerWidth = videoContainer.clientWidth;
    const containerHeight = videoContainer.clientHeight;

    // Calculate the aspect ratio
    const aspectRatio = 9 / 16; // 16:9 aspect ratio
    const containerAR = containerHeight / containerWidth;

    const videoEl = innerContainer.querySelector('video');

    // Compare width and height, and adjust accordingly
    if (containerAR > aspectRatio && (isRokidOnMain || isRokidOnMainInConf)) {
      // Set inner div width to 100%
      innerContainer.style.width = '100%';
      innerContainer.style.height = 'auto';
      innerContainer.style.aspectRatio = '16/9';
      if (videoEl) videoEl.style.objectFit = '';
    } else if (containerAR < aspectRatio && (isRokidOnMain || isRokidOnMainInConf)) {
      // Set inner div height to 100%
      innerContainer.style.width = 'auto';
      innerContainer.style.height = '100%';
      innerContainer.style.aspectRatio = '16/9';
      if (videoEl) videoEl.style.objectFit = '';
    }
    else {
      // Web assistant on main: fill full container, use contain to show full video
      innerContainer.style.width = '100%';
      innerContainer.style.height = '100%';
      innerContainer.style.aspectRatio = 'unset';
      if (videoEl) videoEl.style.objectFit = 'contain';
    }
  };
  // by Deepika - ends here

  useEffect(() => {
    // ====== AGORA: Initialize and join channel ======
    if (roomDetails?.roomId && roomDetails?.appId && !isPluginAttached) {
      const initAgora = async () => {
        // Mutex guard: prevent concurrent Agora joins (Bug 1)
        if (isJoiningRef.current || isLeavingCallRef.current) return;
        isJoiningRef.current = true;
        try {
          // Clean up any stale Agora state from previous calls
          if (agoraClient) {
            try {
              if (localAudioTrackAgora) { localAudioTrackAgora.stop(); localAudioTrackAgora.close(); localAudioTrackAgora = null; }
              if (localVideoTrackAgora) { localVideoTrackAgora.stop(); localVideoTrackAgora.close(); localVideoTrackAgora = null; }
              await agoraClient.leave();
            } catch (e) { /* ignore cleanup errors */ }
            agoraClient = null;
          }
          remoteUsers = {};
          participantRoles = {};

          const AgoraRTC = (await import("agora-rtc-sdk-ng")).default;
          AgoraRTC.setLogLevel(3);

          // h264 is universally hardware-accelerated (iOS, Android, Windows, Mac).
          // vp8 is software-only on most mobile chips → CPU thermal throttle → stream drops.
          // Using a single codec avoids Agora edge transcoding (not guaranteed on NA/EU edges).
          const isMobileBrowser = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
          agoraClient = AgoraRTC.createClient({ mode: "live", codec: "h264", role: "host" });

          // Enable dual-stream for adaptive quality on poor networks
          await agoraClient.enableDualStream();

          // Read conference flag from sessionStorage for reliable detection
          const isConfCall = sessionStorage.getItem("isConferenceCall") === "true";

          // Subscribe to remote users
          agoraClient.on("user-published", async (user, mediaType) => {
            const confFlag = sessionStorage.getItem("isConferenceCall") === "true";

            // ALWAYS subscribe to all tracks (audio + video) from all users.
            // Audio routing is controlled via audioTrack.stop()/play() in toggleMutedStates,
            // not by subscribe/unsubscribe, to avoid race conditions.
            try {
              await agoraClient.subscribe(user, mediaType);
            } catch (subscribeErr) {
              // Error 2021: remote user unpublished/left before our subscribe resolved (race condition).
              // This is benign — the track is gone, nothing to play.
              if (subscribeErr?.code === 2021 || subscribeErr?.message?.includes('no such stream id')) {
                 return;
              }
              throw subscribeErr;
            }
            remoteUsers[user.uid] = user;

            // Auto-assign role based on deterministic UID
            if (!participantRoles[user.uid]) {
              if (user.uid === AGORA_UID_WEBASSISTANT) {
                participantRoles[user.uid] = 'webassistant';
              } else if (user.uid === AGORA_UID_ROKID) {
                participantRoles[user.uid] = 'rokid';
              } else {
                // Any other UID defaults to rokid (smart glass)
                participantRoles[user.uid] = 'rokid';
              }
            }

            if (mediaType === "video") {
              const role = participantRoles[user.uid];
              const confFlag = sessionStorage.getItem("isConferenceCall") === "true";

              // Web assistant camera came back on — hide their avatar
              if (user.uid === AGORA_UID_WEBASSISTANT) {
                setIsWebAstCameraOff(false);
              }

              if (confFlag) {
                if (role === "webassistant") {
                  // Guard: ref may be null if Agora fires user-published before React finishes painting
                  // (common on US/low-latency edge servers). Retry once after 300ms if not ready.
                  if (remoteVideoRef1.current) {
                    user.videoTrack.play(remoteVideoRef1.current, { fit: 'contain' });
                  } else {
                    setTimeout(() => {
                      if (remoteVideoRef1.current) user.videoTrack.play(remoteVideoRef1.current, { fit: 'contain' });
                    }, 300);
                  }
                  setIsWebAstJoin(true);
                  // Pick up the entered name if SET_WEB_AST_NAME arrived before this listener bound
                  const storedWebAstName = sessionStorage.getItem("webAssitName");
                  if (storedWebAstName) setWebAstName(storedWebAstName);
                  sessionStorage.setItem("isWebAssistantJoin", JSON.stringify(true));
                  const keyExists = sessionStorage.getItem('isWebAssistant') !== null;
                  if (!keyExists) {
                    sessionStorage.setItem("isWebAssistant", JSON.stringify(true));
                  }

                  // Since all audio is always subscribed, just ensure playback state is correct.
                  // If WAST is on main view, play their audio track.
                  const isWebAssistantOnMainNow = sessionStorage.getItem('isWebAssistant') === "true";
                  const webAstUser = remoteUsers[AGORA_UID_WEBASSISTANT];
                  if (isWebAssistantOnMainNow && webAstUser && webAstUser.audioTrack) {
                    webAstUser.audioTrack.play();
                  }

                  setInviteDialog(false);
                  isWAConferenceCallRef.current = true;
                } else {
                  if (remoteVideoRef2.current) {
                    user.videoTrack.play(remoteVideoRef2.current);
                  } else {
                    setTimeout(() => {
                      if (remoteVideoRef2.current) user.videoTrack.play(remoteVideoRef2.current);
                    }, 300);
                  }
                  setIsRokidAstJoin(true);
                  sessionStorage.setItem("isRokidAstJoin", JSON.stringify(true));
                }
              } else {
                if (remoteVideoRef1.current) {
                  user.videoTrack.play(remoteVideoRef1.current);
                } else {
                  setTimeout(() => {
                    if (remoteVideoRef1.current) user.videoTrack.play(remoteVideoRef1.current);
                  }, 300);
                }
              }

              if (callJoinToneRef.current) {
                callJoinToneRef.current.currentTime = 0;
                callJoinToneRef.current.play();
              }

              if (confFlag) {
                handleConsultantAudioTransmit();
                // Mute the side-menu user's outgoing mic, unmute main-view user's mic
                const currentMainView = sessionStorage.getItem("isWebAssistant");
                if (currentMainView === "true") {
                  socketRef.current?.emit(WAST_MAIN_VIEW, sessionIdRef.current);
                } else if (currentMainView === "false") {
                  socketRef.current?.emit(ROKID_MAIN_VIEW, sessionIdRef.current);
                }
              }

              setIsRemoteVideo(true);
              maintainAspectRatio();
              handleStart();
            }

            if (mediaType === "audio") {
              if (confFlag) {
                // In conference: only play audio for the user currently on main view.
                // All audio tracks are subscribed, but only main-view user is heard.
                const currentMainView = sessionStorage.getItem('isWebAssistant');
                const isOnMainView = (user.uid === AGORA_UID_WEBASSISTANT && (currentMainView === "true" || currentMainView === null))
                  || (user.uid === AGORA_UID_ROKID && currentMainView === "false");

                if (isOnMainView && user.audioTrack) {
                  user.audioTrack.play();
                 } else if (user.audioTrack) {
                  // Side-view user: subscribed but NOT playing
                  logger.info(`[Consultant] Audio subscribed but NOT playing for UID=${user.uid} (side view)`);
                }
                // Emit audio routing so WAST/Glass get the correct ON/OFF_AUDIO event
                handleConsultantAudioTransmit();
              } else {
                user.audioTrack.play();
              }
              setRemoteAudioTrack(user.audioTrack);
            }
          });

          agoraClient.on("user-unpublished", (user, mediaType) => {
            if (mediaType === "video") {
              // Web assistant is still in the call but stopped their video — show avatar
              if (user.uid === AGORA_UID_WEBASSISTANT) {
                setIsWebAstCameraOff(true);
              }
            }
          });

          agoraClient.on("user-left", (user) => {
            delete remoteUsers[user.uid];
            delete participantRoles[user.uid];
            // Web assistant left entirely — clear the camera-off avatar
            if (user.uid === AGORA_UID_WEBASSISTANT) {
              setIsWebAstCameraOff(false);
            }
          });

          // Handle connection state changes for reconnection
          agoraClient.on("connection-state-change", (curState, prevState, reason) => {
          if (curState === "CONNECTING") {
              // Agora started its own internal reconnect — cancel our pending manual
              // reconnect timer so both don't run concurrently. reason is always
              // undefined here because Agora only supplies reason on disconnection,
              // not on reconnect-start transitions.
              if (agoraReconnectTimer) { clearTimeout(agoraReconnectTimer); agoraReconnectTimer = null; }
              isManuallyReconnecting = false;
            } else if (curState === "RECONNECTING") {
              toast.warning("Network unstable, reconnecting...");
              // Agora is self-recovering — cancel any pending manual reconnect and reset flag
              if (agoraReconnectTimer) { clearTimeout(agoraReconnectTimer); agoraReconnectTimer = null; }
              isManuallyReconnecting = false;
            } else if (curState === "RECONNECTED" || curState === "CONNECTED") {
              if (curState === "RECONNECTED") toast.success("Connection restored");
              // Cancel any pending manual reconnect — connection is up
              if (agoraReconnectTimer) { clearTimeout(agoraReconnectTimer); agoraReconnectTimer = null; }
              isManuallyReconnecting = false;
              // Re-publish local tracks after reconnection
              rePublishLocalTracks();
            } else if (curState === "DISCONNECTED") {
              // Reconnect for any reason except intentional leave.
              // US/global Agora edges fire "NETWORK_TIMEOUT" or undefined — not just "NETWORK_ERROR".
              if (reason !== "LEAVE") {
                toast.error("Connection lost. Attempting to reconnect...");
                scheduleManualReconnect();
              }
            }
          });

          // Monitor network quality for adaptive behavior
          agoraClient.on("network-quality", (stats) => {
            networkQualityDownlinkLevel = stats.downlinkNetworkQuality;
            // Downlink quality: 0=unknown, 1=excellent, 2=good, 3=poor, 4=bad, 5=very bad, 6=disconnected
            if (stats.downlinkNetworkQuality >= 4 || stats.uplinkNetworkQuality >= 4) {
             // Switch remote streams to low quality on poor network
              Object.keys(remoteUsers).forEach(uid => {
                try { agoraClient.setRemoteVideoStreamType(Number(uid), 1); } catch (e) { /* ignore */ }
              });
            } else if (stats.downlinkNetworkQuality <= 2 && stats.uplinkNetworkQuality <= 2) {
              // Good network - use high quality streams
              Object.keys(remoteUsers).forEach(uid => {
                try { agoraClient.setRemoteVideoStreamType(Number(uid), 0); } catch (e) { /* ignore */ }
              });
            }
          });

          // Handle stream fallback events (when remote video degrades to audio-only)
          agoraClient.on("stream-fallback", (uid, isFallbackOrRecover) => {
            if (isFallbackOrRecover === "fallback") {
            toast.warning("Video quality reduced due to network conditions");
            } else if (isFallbackOrRecover === "recover") {
              logger.info("Remote user", uid, "video recovered from fallback");
            }
          });

          // Browser autoplay policy blocked audio/video playback (common on Chrome/Edge when
          // the page loaded without a prior user gesture, e.g. auto-redirect from notification).
          // Show a persistent toast so the consultant knows to click anywhere to unblock.
          agoraClient.on("autoplay-failed", () => {
            toast.info("Audio blocked by browser — click anywhere on the page to enable audio.", {
              toastId: "autoplay-failed",   // prevent duplicate toasts
              autoClose: false,             // keep visible until user acts
              closeOnClick: true,
              onClick: () => {
                // Resume AudioContext on click (Safari/Chrome mobile requirement)
                if (typeof window.AudioContext !== 'undefined' || typeof window.webkitAudioContext !== 'undefined') {
                  const AudioCtx = window.AudioContext || window.webkitAudioContext;
                  try { new AudioCtx().resume(); } catch (_) { /* ignore */ }
                }
              }
            });
            logger.warn('Agora autoplay-failed: browser blocked audio/video playback');
          });

          // Handle token expiry - request new token before it expires
          agoraClient.on("token-privilege-will-expire", async () => {
          // The socket reconnect flow will provide a fresh token via roomDetails update
          });

          agoraClient.on("token-privilege-did-expire", async () => {
           toast.error("Session token expired. Reconnecting...");
            // Reset lastJoinedTokenRef so reconnectAgora will rejoin when a new
            // token arrives via REJOIN_ROOM/REJOIN_CONFERENCE_ROOM (Bug 2).
            // Do NOT call setIsPluginAttached(false) here: that re-triggers initAgora
            // with the already-expired token causing an immediate failed join.
            lastJoinedTokenRef.current = null;
          });

          // Cloud Proxy mode 5 (auto): tries direct UDP first, silently falls back to
          // Agora's TLS-443 proxy if UDP is blocked (corporate firewalls, hospital networks).
          // Safe to enable always — adds <100ms overhead only when fallback actually triggers.
          try {
            await agoraClient.startProxyServer(5);
          } catch (proxyErr) {
            logger.warn('Cloud Proxy start failed, joining without proxy', { error: proxyErr.message });
          }

          // Join channel - consultant uses deterministic UID=1
          const uid = await agoraClient.join(
            roomDetails.appId,
            roomDetails.channel,
            roomDetails.token,
            AGORA_UID_CONSULTANT
          );

          // Create and publish local tracks - use audio-only first (same as dial call)
          // then add video if needed and available
          localAudioTrackAgora = await AgoraRTC.createMicrophoneAudioTrack({
            AEC: true,  // Acoustic Echo Cancellation
            ANS: true,  // Automatic Noise Suppression
            AGC: true,  // Automatic Gain Control - critical for mobile
            encoderConfig: "high_quality_stereo"
          });

          if (isConfCall) {
            try {
              // Use higher quality video config with optimizationMode for smooth motion
              const videoEncoderConfig = isMobileBrowser
                ? { width: 640, height: 480, frameRate: 24, bitrateMin: 400, bitrateMax: 1000 }
                : { width: 1280, height: 720, frameRate: 30, bitrateMin: 800, bitrateMax: 2000 };
              localVideoTrackAgora = await AgoraRTC.createCameraVideoTrack({
                encoderConfig: videoEncoderConfig,
                optimizationMode: "detail"  // prioritize clarity over smoothness
              });
            } catch (videoError) {
             localVideoTrackAgora = null;
            }
          }

          const tracksToPublish = [localAudioTrackAgora, localVideoTrackAgora].filter(Boolean);
          await agoraClient.publish(tracksToPublish);

          if (localVideoTrackAgora && localVideoRef.current) {
            localVideoTrackAgora.play(localVideoRef.current);
            // Re-apply the selected virtual background onto the new camera track.
            reapplyVirtualBackground();
          }

          setLocalAudioTrack(localAudioTrackAgora);
          setIsPluginAttached(true);
          lastJoinedTokenRef.current = roomDetails.token;

          // Start bitrate calculation
          calculateBitrate();
        } catch (error) {
          logger.error("Agora init error:", error);
        } finally {
          isJoiningRef.current = false;
        }
      };
      initAgora();
    }
  }, [roomDetails, isPluginAttached]);

  // AGORA: Handle reconnection when new roomDetails arrive while already connected
  useEffect(() => {
    if (roomDetails?.roomId && roomDetails?.appId && isPluginAttached && agoraClient) {
      const reconnectAgora = async () => {
        // Guards: skip if call is ending, join is in progress, or token unchanged (Bug 1 & 3)
        if (isLeavingCallRef.current || isJoiningRef.current) return;
        if (roomDetails?.token === lastJoinedTokenRef.current) return;
        isJoiningRef.current = true;
        try {
        // Leave old channel
          if (localAudioTrackAgora) { localAudioTrackAgora.stop(); localAudioTrackAgora.close(); localAudioTrackAgora = null; }
          if (localVideoTrackAgora) { localVideoTrackAgora.stop(); localVideoTrackAgora.close(); localVideoTrackAgora = null; }
          await agoraClient.leave();
          remoteUsers = {};
          participantRoles = {};

          const isConfCall = sessionStorage.getItem("isConferenceCall") === "true";

          // Rejoin with new token
          await agoraClient.join(
            roomDetails.appId,
            roomDetails.channel,
            roomDetails.token,
            AGORA_UID_CONSULTANT
          );

          const AgoraRTC = (await import("agora-rtc-sdk-ng")).default;
          localAudioTrackAgora = await AgoraRTC.createMicrophoneAudioTrack({ AEC: true, ANS: true, AGC: true, encoderConfig: "high_quality_stereo" });

          if (isConfCall) {
            try {
              const isMobileBrowser = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
              const videoEncoderConfig = isMobileBrowser
                ? { width: 640, height: 480, frameRate: 24, bitrateMin: 400, bitrateMax: 1000 }
                : { width: 1280, height: 720, frameRate: 30, bitrateMin: 800, bitrateMax: 2000 };
              localVideoTrackAgora = await AgoraRTC.createCameraVideoTrack({
                encoderConfig: videoEncoderConfig,
                optimizationMode: "detail"
              });
            } catch (videoError) {
               localVideoTrackAgora = null;
            }
          }

          const tracksToPublish = [localAudioTrackAgora, localVideoTrackAgora].filter(Boolean);
          await agoraClient.publish(tracksToPublish);

          if (localVideoTrackAgora && localVideoRef.current) {
            localVideoTrackAgora.play(localVideoRef.current);
            // Re-apply the selected virtual background onto the new camera track.
            reapplyVirtualBackground();
          }

          setLocalAudioTrack(localAudioTrackAgora);
          lastJoinedTokenRef.current = roomDetails.token;
      } catch (error) {
        // Reset state to allow fresh initialization on next roomDetails change
          setIsPluginAttached(false);
        } finally {
          isJoiningRef.current = false;
        }
      };
      reconnectAgora();
    }
  }, [roomDetails?.token]);

  // useEffect for display network status and display popup when user click on browser window back button.
  useEffect(() => {
    if (failedPong === 2) toast.warning(t('responseMsg.msg_unstableConnection'));
    if (failedPong === 5) {
      toast.error(t('responseMsg.msg_connectionLostWithServer'));
      navigate('/dashboard/assistants');
    }
  }, [failedPong, navigate]);

  // commenting code but leaving as is for now - may need
  // useEffect(() => {
  //   let timeoutId;
  //   if (navigationBackPopup || recordingPopup) {
  //     timeoutId = setTimeout(() => { // Set a timeout for 30 seconds
  //       setNavigationBackPopup(false); // Close the navigate back popup after 30 seconds if there's no user interaction 
  //       setRecordingPopup(false); // close the recording ended popup after 30 seconds if no user interaction
  //     }, 30000);
  //   }
  //   // Clean up the timeout if the popup is closed before timeout
  //   return () => clearTimeout(timeoutId);
  // }, [navigationBackPopup, recordingPopup]);

  useEffect(() => {
    intervalId = setInterval(() => {
      dataConsumption(dataSent, false);
      setDataUsageTimer(dataUsageTimer + 1);
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);

  function onMouseDown(e) {
    const pointer = canvas.getPointer(e);
    if (isDrawing) {
      arr_coords.push({
        x: pointer.x * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
        y: pointer.y * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
      });
    }
  }

  function onMouseUp(e) {
    const pointer = canvas.getPointer(e);
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    if (canvas.isDrawingMode) {
      arr_coords.push({
        x: pointer.x * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
        y: pointer.y * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
      });
      socketRef.current?.emit(DRAW_FREEHAND, { coords: arr_coords, sessionId: sessionIdRef.current, webAssistantViewFlag });
      arr_coords = [];
      canvas.isDrawingMode = false;
      var objects = canvas.getObjects();
      var paths = objects.filter(function (obj) {
        return obj instanceof fabric.Path;
      });
      paths[0].lockMovementX = true;
      paths[0].lockMovementY = true;
    }
  }

  function drawRealTime(e, pointer) {
    if (isDrawing) {
      arr_coords.push({
        x: pointer.x * (coordsTransformRatio(vWidth, vHeight).transformXRatio),
        y: pointer.y * (coordsTransformRatio(vWidth, vHeight).transformYRatio),
      });
    }
  }

  // ====== AGORA: Re-publish local tracks after reconnection ======
  const rePublishLocalTracks = async () => {
    try {
      if (!agoraClient) return;
      const tracksToPublish = [localAudioTrackAgora, localVideoTrackAgora].filter(Boolean);
      if (tracksToPublish.length > 0) {
      await agoraClient.publish(tracksToPublish);
      }
    } catch (e) {
      // Tracks may already be published - ignore ALREADY_PUBLISHED errors
      if (!e.message?.includes("ALREADY")) {
        logger.info("Failed to re-publish tracks:", e);
      }
    }
  };

  // ====== AGORA: Manual reconnect scheduler ======
  const scheduleManualReconnect = () => {
    if (agoraReconnectTimer) clearTimeout(agoraReconnectTimer);
    agoraReconnectTimer = setTimeout(async () => {
      agoraReconnectTimer = null;
      const invalidStates = ["CONNECTING", "RECONNECTING", "CONNECTED"];
      if (!agoraClient || isLeavingCallRef.current || invalidStates.includes(agoraClient.connectionState)) return;
      // Prevent duplicate concurrent manual reconnect attempts
          if (isManuallyReconnecting) {
              return;
          }
       isManuallyReconnecting = true;
      try {
        // Try leaving cleanly first
        try { await agoraClient.leave(); } catch (e) { /* ignore */ }
        // Rejoin
        if (roomDetails?.appId && roomDetails?.channel && roomDetails?.token) {
          await agoraClient.join(
            roomDetails.appId,
            roomDetails.channel,
            roomDetails.token,
            AGORA_UID_CONSULTANT
          );
          await rePublishLocalTracks();
          toast.success("Reconnected successfully");
        } else {
          // No room details available - cannot reconnect; avoid resetting isPluginAttached
          // which would re-trigger initAgora with stale/no token (Bug 2)
          logger.info("Manual reconnect skipped - no room details available");
        }
      } catch (e) {
        toast.error("Reconnection failed. Please check your network.");
        // Retry with exponential backoff (max 30s)
        agoraReconnectTimer = setTimeout(() => scheduleManualReconnect(), 15000);
      } finally {
        isManuallyReconnecting = false;
      }
    }, 3000);
  };

  // ====== AGORA: Cleanup helper ======
  const cleanupAgora = async () => {
    try {
      if (agoraReconnectTimer) {
        clearTimeout(agoraReconnectTimer);
        agoraReconnectTimer = null;
      }
      networkQualityDownlinkLevel = 0;
      // Tear down the virtual background processor before closing the camera track.
      if (virtualBgProcessor) {
        try { await virtualBgProcessor.disable(); } catch (_) { /* ignore */ }
        try { if (localVideoTrackAgora && virtualBgPiped) localVideoTrackAgora.unpipe(); } catch (_) { /* ignore */ }
        try { await virtualBgProcessor.release(); } catch (_) { /* ignore */ }
        virtualBgProcessor = null;
      }
      virtualBgPiped = false;
      if (localAudioTrackAgora) {
        localAudioTrackAgora.stop();
        localAudioTrackAgora.close();
        localAudioTrackAgora = null;
      }
      if (localVideoTrackAgora) {
        localVideoTrackAgora.stop();
        localVideoTrackAgora.close();
        localVideoTrackAgora = null;
      }
      if (agoraClient) {
        agoraClient.removeAllListeners();
        await agoraClient.leave();
        agoraClient = null;
      }
      remoteUsers = {};
      participantRoles = {};
    } catch (e) {
      logger.error("Agora cleanup error:", e);
    }
  };

  // ====== Virtual background helpers ======
  // Load an image URL into an HTMLImageElement (used for "img" backgrounds).
  const loadBackgroundImage = (src) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = src;
    });

  // Load a DB-backed background's bytes through the API (same-origin proxy),
  // then decode from a blob: URL. This avoids needing S3-bucket CORS: the image never comes cross-origin, so the Agora canvas isn't tainted.
  const loadBackgroundImageViaProxy = async (bgId) => {
    const res = await apis.instance.get(VirtualBackgroundImageRoute(bgId), { responseType: "blob" });
    const objectUrl = URL.createObjectURL(res.data);
    try {
      return await new Promise((resolve, reject) => {
        const img = new Image(); // no crossOrigin needed for a same-origin blob: URL
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = objectUrl;
      });
    } finally {
      // The HTMLImageElement keeps its decoded bitmap after load, so it's safe to release the blob URL now.
      URL.revokeObjectURL(objectUrl);
    }
  };

  // Lazily register the extension (once) and create the processor (once).
  // Returns null if the browser can't support the extension.
  const ensureVirtualBgProcessor = async () => {
    if (!virtualBgExtension) {
      const VirtualBackgroundExtension = (await import("agora-extension-virtual-background")).default;
      const AgoraRTC = (await import("agora-rtc-sdk-ng")).default;
      const ext = new VirtualBackgroundExtension();
      if (!ext.checkCompatibility()) {
        logger.error("[VirtualBg] Browser does not support virtual background");
        return null;
      }
      AgoraRTC.registerExtensions([ext]);
      virtualBgExtension = ext;
    }
    if (!virtualBgProcessor) {
      virtualBgProcessor = virtualBgExtension.createProcessor();
      await virtualBgProcessor.init(); // wasm is inlined in v2.x, no path needed
    }
    return virtualBgProcessor;
  };

  // Apply (or clear) a virtual background on the consultant's local camera track.
  // Fail-safe: any error leaves the raw camera feed intact.
  const applyVirtualBackground = async (bgId) => {
    const bg = allBgOptionsRef.current.find((b) => b.id === bgId) || { id: "none", type: "none" };
    // No local camera (e.g. non-conference call) -> nothing to do.
    if (!localVideoTrackAgora) return;
    try {
      // "none" -> disable the effect, keep the raw camera.
      if (bg.type === "none") {
        if (virtualBgProcessor && virtualBgPiped) {
          await virtualBgProcessor.disable();
        }
        return;
      }

      const processor = await ensureVirtualBgProcessor();
      if (!processor) {
        toast.error("Virtual background is not supported on this device/browser.");
        return;
      }

      // Pipe the processor into the current track once.
      if (!virtualBgPiped) {
        localVideoTrackAgora.pipe(processor).pipe(localVideoTrackAgora.processorDestination);
        virtualBgPiped = true;
      }

      if (bg.type === "blur") {
        processor.setOptions({ type: "blur", blurDegree: bg.blurDegree || 2 });
      } else if (bg.type === "img") {
        // DB-backed images (numeric id) go through the same-origin API proxy so
        // no S3 CORS is required; anything else falls back to a direct URL load.
        const img = typeof bg.id === "number"
          ? await loadBackgroundImageViaProxy(bg.id)
          : await loadBackgroundImage(bg.src);
        processor.setOptions({ type: "img", source: img, fit: "cover" });
      }
      await processor.enable();
    } catch (e) {
      logger.error("[VirtualBg] Failed to apply virtual background:", e);
      // Fail-safe: fall back to the raw camera feed.
      try {
        if (virtualBgProcessor && virtualBgPiped) await virtualBgProcessor.disable();
      } catch (_) { /* ignore */ }
    }
  };

  // Re-apply the current selection onto a freshly (re)created camera track.
  // The processor was piped to the previous (now closed) track, so reset the
  // pipe flag first and let applyVirtualBackground re-pipe into the new track.
  const reapplyVirtualBackground = () => {
    if (!localVideoTrackAgora) return;
    if (!virtualBgRef.current || virtualBgRef.current === "none") return;
    virtualBgPiped = false;
    applyVirtualBackground(virtualBgRef.current);
  };

  // Rebuild the flat lookup list (used by applyVirtualBackground) from the
  // static options plus the fetched default/user image backgrounds.
  const rebuildBgOptions = (defaults, mine) => {
    const toOption = (b) => ({ id: b.id, type: "img", src: b.imageUrl, name: b.name });
    allBgOptionsRef.current = [
      { id: "none", type: "none" },
      { id: "blur", type: "blur", blurDegree: 2 },
      ...defaults.map(toOption),
      ...mine.map(toOption),
    ];
  };

  // Fetch default + user backgrounds (and the persisted selection) from the API.
  // When syncSelection is true (initial load / new call) we also adopt the
  // server-side selection and auto-apply it onto the current camera track.
  const fetchBackgrounds = async ({ syncSelection = false } = {}) => {
    try {
      setBgsLoading(true);
      const { data } = await apis.instance.get(GetVirtualBackgroundsRoute);
      const payload = data?.data || {};
      const defaults = payload.defaultBackgrounds || [];
      const mine = payload.myBackgrounds || [];
      setDefaultBgs(defaults);
      setMyBgs(mine);
      rebuildBgOptions(defaults, mine);

      if (syncSelection) {
        // Restore the persisted selection: BLUR -> "blur", IMAGE -> its id,
        // anything else -> "none".
        let selected = "none";
        if (payload.selectedMode === "BLUR") {
          selected = "blur";
        } else if (payload.selectedMode === "IMAGE" && payload.selectedBackgroundId) {
          selected = payload.selectedBackgroundId;
        }
        setVirtualBg(selected);
        virtualBgRef.current = selected;
        setPendingBg(selected);
        // If the camera is already live, apply immediately.
        if (localVideoTrackAgora && selected !== "none") {
          virtualBgPiped = false;
          applyVirtualBackground(selected);
        }
      }
    } catch (e) {
      logger.error("[VirtualBg] Failed to fetch backgrounds:", e);
    } finally {
      setBgsLoading(false);
    }
  };

  // Persist the selected background (best-effort). "none"/"blur" clear the
  // stored selection; a numeric id selects that background.
  const persistSelection = async (bgId) => {
    try {
      if (bgId === "none") {
        await apis.instance.put(ClearVirtualBackgroundSelectionRoute);
      } else if (bgId === "blur") {
        await apis.instance.put(BlurVirtualBackgroundSelectionRoute);
      } else {
        await apis.instance.put(SelectVirtualBackgroundRoute(bgId));
      }
      return true;
    } catch (e) {
      logger.error("[VirtualBg] Failed to persist selection:", e);
      return false;
    }
  };

  // Open the picker dialog, pre-selecting whatever is currently applied, and
  // refresh the list so pre-signed image urls are current.
  const openBgDialog = () => {
    setPendingBg(virtualBg);
    setBgDialogOpen(true);
    fetchBackgrounds();
  };

  // Apply the highlighted selection to the consultant view, persist it, close.
  const handleApplyVirtualBg = async () => {
    setApplyingBg(true);
    try {
      setVirtualBg(pendingBg);
      virtualBgRef.current = pendingBg;
      await applyVirtualBackground(pendingBg);
      const saved = await persistSelection(pendingBg);
      if (!saved) {
        toast.error(t("msg_bgSaveFailed", "Background applied but could not be saved for next time."));
      }
    } finally {
      setApplyingBg(false);
      setBgDialogOpen(false);
    }
  };

  // Read a File into a base64 data-uri string.
  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  // Trigger the hidden file input when "Add Background" is clicked.
  const handleAddBackgroundClick = () => {
    if (bgFileInputRef.current) bgFileInputRef.current.click();
  };

  // Validate + upload a chosen file, then add it to "My Backgrounds".
  const handleBgFileSelected = async (event) => {
    const file = event.target.files && event.target.files[0];
    // Reset the input so selecting the same file again re-triggers onChange.
    event.target.value = "";
    if (!file) return;

    const allowed = ["image/png", "image/jpeg", "image/webp"];
    if (!allowed.includes(file.type)) {
      toast.error(t("msg_bgInvalidType", "Please choose a PNG, JPG or WEBP image."));
      return;
    }
    const MAX_BYTES = 5 * 1024 * 1024;
    if (file.size > MAX_BYTES) {
      toast.error(t("msg_bgTooLarge", "Image is too large. Maximum size is 5 MB."));
      return;
    }

    setUploadingBg(true);
    try {
      const dataUri = await fileToDataUri(file);
      const name = file.name.replace(/\.[^/.]+$/, "").slice(0, 100) || "My Background";
      const { data } = await apis.instance.post(UploadVirtualBackgroundRoute, { name, image: dataUri });
      const created = data?.data;
      if (created && created.id) {
        const nextMine = [created, ...myBgs];
        setMyBgs(nextMine);
        rebuildBgOptions(defaultBgs, nextMine);
        // Highlight (but don't force-apply) the freshly uploaded image.
        setPendingBg(created.id);
        toast.success(t("msg_bgUploaded", "Background added."));
      }
    } catch (e) {
      logger.error("[VirtualBg] Upload failed:", e);
      const serverMsg = e?.response?.data?.error;
      toast.error(serverMsg || t("msg_bgUploadFailed", "Failed to upload background. Please try again."));
    } finally {
      setUploadingBg(false);
    }
  };

  // Delete one of the user's own uploaded backgrounds.
  const handleDeleteBackground = async (bgId, e) => {
    if (e) e.stopPropagation();
    setDeletingBgId(bgId);
    try {
      await apis.instance.delete(DeleteVirtualBackgroundRoute(bgId));
      const nextMine = myBgs.filter((b) => b.id !== bgId);
      setMyBgs(nextMine);
      rebuildBgOptions(defaultBgs, nextMine);

      // If the deleted background was applied/highlighted, fall back to "none".
      if (pendingBg === bgId) setPendingBg("none");
      if (virtualBg === bgId) {
        setVirtualBg("none");
        virtualBgRef.current = "none";
        applyVirtualBackground("none");
      }
      toast.success(t("msg_bgDeleted", "Background removed."));
    } catch (err) {
      logger.error("[VirtualBg] Delete failed:", err);
      // Do NOT remove from the UI if the backend call failed.
      toast.error(t("msg_bgDeleteFailed", "Failed to remove background. Please try again."));
    } finally {
      setDeletingBgId(null);
    }
  };

  // Render a single background tile (used by both dialog sections).
  const renderBgTile = (bg) => (
    <Box
      key={bg.id}
      onClick={() => setPendingBg(bg.id)}
      sx={{ cursor: "pointer", gridColumn: "span 2", borderRadius: 1, overflow: "hidden", border: pendingBg === bg.id ? "2px solid #1976d2" : "2px solid transparent" }}
    >
      <Box sx={{ position: "relative", width: "100%", aspectRatio: "16/9", bgcolor: bg.type === "blur" ? "#757575" : "#2b2b2b", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {bg.type === "img" && (
          <img src={bg.src} alt={bg.label} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        )}
        {bg.type === "blur" && (
          <Typography variant="caption" sx={{ color: "#fff" }}>{t("lbl_blur", "Blur")}</Typography>
        )}
        {bg.type === "none" && (
          <Typography variant="caption" sx={{ color: "#fff" }}>{t("lbl_noBackground", "No background")}</Typography>
        )}
        {pendingBg === bg.id && (
          <CheckIcon fontSize="small" sx={{ position: "absolute", top: 4, right: 4, color: "#1976d2", backgroundColor: "#fff", borderRadius: "50%" }} />
        )}
        {bg.deletable && (
          <IconButton
            size="small"
            aria-label="delete-background"
            disabled={deletingBgId === bg.id}
            onClick={(e) => handleDeleteBackground(bg.id, e)}
            sx={{ position: "absolute", top: 2, left: 2, color: "#fff", backgroundColor: "rgba(0,0,0,0.45)", "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" }, p: 0.3 }}
          >
            <DeleteOutlineIcon fontSize="inherit" />
          </IconButton>
        )}
      </Box>
    </Box>
  );

  // Load the user's persisted virtual-background selection once the call is a conference call (where the consultant's camera/self-view exists), and auto-apply it. 
  useEffect(() => {
    if (isConferenceCall) {
      fetchBackgrounds({ syncSelection: true });
    }
  }, [isConferenceCall]);

  // ====== AGORA: calculateBitrate using Agora stats ======
  const calculateBitrate = () => {
    setInterval(async () => {
      if (!agoraClient) return;
      try {
        const localStats = agoraClient.getLocalVideoStats();
        if (localStats && localStats.sendBytes) {
          const bytesSentNow = localStats.sendBytes;
          if (bytesSentNow >= prevBytesSent) {
            const delta = bytesSentNow - prevBytesSent;
            dataSent = ((prevBytesSent + delta) / (1024 * 1024));
            prevBytesSent = bytesSentNow;
          }
        }
      } catch (e) {
        logger.error("Failed to get Agora stats:", e);
      }
    }, 1000);
  };

  const getLocalMicStream = async () => {
    try {
      const constraints = { audio: true, video: false }; // Request only audio
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      setConsAudio(stream);
      return stream;
    } catch (error) {
      logger.error("Error accessing local microphone:", error);
      return null;
    }
  }

  // RECORDING HANDLER
  const handleStartRecording = async () => {
    let webAssistantFlag = (isMainView && isWebAstJoin) ? 1 : 0;
    const isWebAstJoinCheck = (sessionStorage.getItem("isWebAssistantJoin") === "true") ?? false;
    const isRokidAstJoinCheck = (sessionStorage.getItem("isRokidAstJoin") === "true") ?? false;
    let destinationNode;
    let recording_canvas = document.querySelector("#recording_canvas");
    var stream = recording_canvas.captureStream(30 /*fps*/);

    if (isConferenceCall) {
      const audioContext = new AudioContext();
      destinationNode = audioContext.createMediaStreamDestination();
      const localAudioFeed = await getLocalMicStream();
      const audioStream1 = localAudioFeed;
      audioStream1.addTrack(localAudioFeed.getAudioTracks()[0]);

      const sourceNode1 = audioContext.createMediaStreamSource(audioStream1);
      sourceNode1.connect(destinationNode);

      if (isWebAstJoinCheck) {
        // AGORA: Get audio track from remote user instead of remoteAudioRef1.current.srcObject
        const webAstUser = Object.values(remoteUsers).find(u => participantRoles[u.uid] === "webassistant");
        if (webAstUser && webAstUser.audioTrack) {
          const audioStream2 = new MediaStream([webAstUser.audioTrack.getMediaStreamTrack()]);
          const sourceNode2 = audioContext.createMediaStreamSource(audioStream2);
          sourceNode2.connect(destinationNode);
        }
      }

      if (isRokidAstJoinCheck) {
        // AGORA: Get audio track from remote rokid user
        const rokidUser = Object.values(remoteUsers).find(u => participantRoles[u.uid] !== "webassistant");
        if (rokidUser && rokidUser.audioTrack) {
          const audioStream3 = new MediaStream([rokidUser.audioTrack.getMediaStreamTrack()]);
          const sourceNode3 = audioContext.createMediaStreamSource(audioStream3);
          sourceNode3.connect(destinationNode);
        }
      }

    } else {
      // 1-to-1 call: use getLocalMicStream for local audio and getMediaStreamTrack() for Agora remote audio
      const audioContext = new AudioContext();
      destinationNode = audioContext.createMediaStreamDestination();

      const localAudioFeed = await getLocalMicStream();
      if (localAudioFeed) {
        const sourceNode1 = audioContext.createMediaStreamSource(localAudioFeed);
        sourceNode1.connect(destinationNode);
      }

      if (remoteAudioTrack && remoteAudioTrack.getMediaStreamTrack) {
        const remoteStream = new MediaStream([remoteAudioTrack.getMediaStreamTrack()]);
        const sourceNode2 = audioContext.createMediaStreamSource(remoteStream);
        sourceNode2.connect(destinationNode);
      }
    }

    let audioTracks = destinationNode.stream.getAudioTracks()[0];
    // create one video and audio stream
    const newStream = new MediaStream();
    newStream.addTrack(audioTracks);
    newStream.addTrack(stream.getVideoTracks()[0]);

    // create a new MediaRecorder
    mediaRecorder = new MediaRecorder(newStream);

    // create an array to store the video chunks
    mediaRecorder.ondataavailable = (event) => {
      chunks.push(event.data);
    };

    if (isMainView && isRokidAstJoin) {
      socketRef.current?.emit(WAST_MAIN_VIEW, sessionIdRef.current);
    } else if (!isMainView && isWebAstJoin) {
      socketRef.current?.emit(ROKID_MAIN_VIEW, sessionIdRef.current);
    }

    mediaRecorder.start();
    socketRef.current?.emit(RECORDING_STARTED, { sessionId: sessionIdRef.current, webAssistantFlag });
    setRecording(true);
    sessionStorage.setItem("isRecording", JSON.stringify(true));
    setRecordingSession("true");
  };

  const handleStopRecording = () => {
    let webAssistantFlag = (isMainView && isWebAstJoin) ? 1 : 0;
    const recordingStarted = sessionStorage.getItem("isRecording") === "true";
    if (mediaRecorder != undefined && recordingStarted) {
      if (mediaRecorder?.state === "recording") {
        mediaRecorder.stop();
        socketRef.current?.emit(RECORDING_ENDED, webAssistantFlag);
        toast.info(t('lbl_recordingStopSaving'));
      }
      setRecording(false);
      sessionStorage.setItem("isRecording", JSON.stringify(false));
      mediaRecorder.onstop = async function (event) {
        var videoBlob = new Blob(chunks, { type: "video/webm" });
        let recordingURL = URL.createObjectURL(videoBlob);
        var link$ = document.createElement("a");
        link$.href = recordingURL;
        link$.download = `call-with-${state?.assistantName}-recording`;
        link$.click();
      };
      chunks = [];
    }
  };

  // draw glass stream draw on canvas for recording and snapshot
  const onPlayHandler = (e) => {
    let canvas = document.querySelector("#canvas");
    let recording_canvas = document.querySelector("#recording_canvas");
    let ctxs = recording_canvas.getContext("2d");
    (function loop() {
      // Clear previous frame to prevent ghosting/artifacts
      ctxs.clearRect(0, 0, 920, 520);
      // Calculate zoomed dimensions based on the canvas dimensions
      let zoomedWidth = 920 * (zoomLevel / 100);
      let zoomedHeight = 520 * (zoomLevel / 100);
      let xOffset = (920 - zoomedWidth) / 2; // Calculate the offset to center horizontally
      let yOffset = (520 - zoomedHeight) / 2; // Calculate the offset to center vertically

      // Use sessionStorage for current join state to avoid stale closure values
      const isWebAstJoinCurrent = sessionStorage.getItem("isWebAssistantJoin") === "true";
      const isRokidAstJoinCurrent = sessionStorage.getItem("isRokidAstJoin") === "true";
      const isConfCall = sessionStorage.getItem("isConferenceCall") === "true";

      if (isConfCall) {
        if (recordMainView && isWebAstJoinCurrent) {
          if (!remoteVideoRef1.current) { setTimeout(loop, 1000 / 120); return; }
          ctxs.drawImage(remoteVideoRef1.current, xOffset, yOffset, zoomedWidth, zoomedHeight);
        } else if (!recordMainView && isRokidAstJoinCurrent) {
          if (!remoteVideoRef2.current) { setTimeout(loop, 1000 / 120); return; }
          ctxs.drawImage(remoteVideoRef2.current, xOffset, yOffset, zoomedWidth, zoomedHeight);
        } else if (recordMainView && isRokidAstJoinCurrent && !isWebAstJoinCurrent) {
          // Only rokid joined, displayed on main via ref1 (1-to-1 within conference)
          if (!remoteVideoRef1.current) { setTimeout(loop, 1000 / 120); return; }
          ctxs.drawImage(remoteVideoRef1.current, xOffset, yOffset, zoomedWidth, zoomedHeight);
        }
      } else {
        if (!remoteVideoRef1.current) { setTimeout(loop, 1000 / 120); return; }
        ctxs.drawImage(remoteVideoRef1.current, xOffset, yOffset, zoomedWidth, zoomedHeight);
      }
      // Draw the canvas (annotations) onto the recording canvas
      ctxs.drawImage(canvas, 0, 0, 920, 520);
      setTimeout(loop, 1000 / 120);
    })();
  };

  //consultant audio from getLocalMicStream using getUserMedia.
  //clear mediaStream on end call.
  const stopMediaStream = () => {
    if (consAudio) {
      consAudio.getTracks().forEach(track => track.stop());
      setConsAudio(null);
    }
  };

  useEffect(() => {
    window.onbeforeunload = () => {
      if (mediaRecorder?.state === "recording") {
        let webAssistantFlag = (isMainView && isWebAstJoin) ? 1 : 0;
        handleStopRecording();
        socketRef.current?.emit(RECORDING_ENDED, webAssistantFlag);
        setRecording(false);
      }
      if (window.location.pathname.includes("/call")) {
        dataConsumption(dataSent, false);
      }
    }
  }, [])

  const handleEndCall = async () => {
    clearInterval(intervalId);
    const recordingStarted = sessionStorage.getItem("isRecording") === "true";
    isRunning = sessionStorage.getItem("isRunning");
    const isRunningString = isRunning === "true";
    if (mediaRecorder?.state === "recording" && recordingStarted) {
      handleStopRecording();
    }
    if (isRunningString) {
      dataConsumption(dataSent, true);
    }
    isLeavingCallRef.current = true;
    await cleanupAgora();
    const assistantName = sessionStorage.getItem("assistantUserName");
    socketRef.current?.emit(END_CALL, { sessionData: sessionIdRef.current, assistantName, callEndUserRole: 3 });
    navigate("/callquality");
    handleReset();
    setIsConferenceCall(false)
    setEmailAddress('');
    sessionStorage.setItem("isConferenceCall", JSON.stringify(false));
    sessionStorage.setItem("isRunning", JSON.stringify(true));
    sessionStorage.removeItem("isWebAssistant");
    sessionStorage.removeItem("assistantUserName");
    sessionStorage.removeItem("rokidWidth");
    sessionStorage.removeItem("rokidHeight");
    sessionStorage.removeItem("isWebAssistantJoin");
    sessionStorage.removeItem("isRokidAstJoin");
    sessionStorage.removeItem("wastSelfMuted");
    SetIsMuteRokid(false);
    SetIsWebAsstMuted(false);
    setWastInviteSent(false);
    setRokidInviteDialog(false);
    isRokidOnMain = true;
    setRokidInviteSent(false);
    recordMainView = true;
    stopMediaStream();
    clearInterval(webassistantIntervalId);
    clearInterval(rokidIntervalId);
    isWAConferenceCallRef.current = false;
  };

  // DRAW RECTANGLE HANDLER - completed
  const drawRectangle = (active) => {
    if (canvas.getObjects().filter((obj) => obj.type === "rect").length > 0) return; else setSelectedIcon(active);
    if (canvas.isDrawingMode) canvas.isDrawingMode = false;
    drawnRect = false;
    drawnCircle = true;
    if (drawnCircle) {
      canvas.off("mouse:down");
      canvas.off("mouse:move");
      canvas.off("mouse:up");
    }
    if (!drawnRect) {
      setIsButtonSelected('rect');
      var rect, isDown, origX, origY, rectDrawn;
      var x = 0;
      var y = 0;

      // mouse down
      canvas.on("mouse:down", function (o) {
        arr_coords = [];
        if (
          canvas.getObjects().filter((obj) => obj.type === "rect").length > 0
        ) {
          return;
        } else {
          isDown = true;
          var pointer = canvas.getPointer(o.e);
          origX = pointer.x;
          origY = pointer.y;
          rect = new fabric.Rect({
            left: origX,
            top: origY,
            fill: "transparent",
            width: 20,
            height: 20,
            strokeWidth: 2,
            stroke: "red",
            hasControls: true,
            hasRotatingPoint: false, // Disable rotating controls
            strokeUniform: true // Ensure stroke width remains constant
          });
          canvas.add(rect);
          // Hide rotating control
          rect.setControlVisible('mtr', false)
        }
      });

      //mouse move event on canvas
      canvas.on("mouse:move", function (o) {
        if (!isDown) return;
        var pointer = canvas.getPointer(o.e);
        var width = Math.abs(pointer.x - origX);
        var height = Math.abs(pointer.y - origY);
        var newLeft = origX > pointer.x ? pointer.x : origX;
        var newTop = origY > pointer.y ? pointer.y : origY;
        rect.set({
          left: newLeft,
          top: newTop,
          width: width,
          height: height
        });
        canvas.renderAll();
      });

      // mouse up
      canvas.on("mouse:up", function (o) {
        isDown = false;
        drawnRect = true;
        let activeRect = canvas.getActiveObject();
        let acoords = activeRect?.aCoords;
        const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
        const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
        let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
        if (!acoords) return;
        rect.setCoords();// Update coordinates of the circle
        canvas.setActiveObject(rect); // Set the circle as the active object
        canvas.renderAll();
        canvas.fire('object:modified', { target: rect });
        canvas.off("mouse:down");
        canvas.off("mouse:move");
        canvas.off("mouse:up");
        setSelectedIcon('');
        setIsButtonSelected('');
      });
    }
    return;
  };

  // DRAW CIRCLE HANDLER
  const handledrawCircle = (active) => {
    sessionStorage.setItem("userTyping", "false")
    if (canvas.getObjects().filter((obj) => obj.type === "circle").length > 0) return; else setSelectedIcon(active);
    drawnCircle = false;
    drawnRect = true;
    if (canvas.isDrawingMode) canvas.isDrawingMode = false;
    if (drawnRect) {
      canvas.off("mouse:down");
      canvas.off("mouse:move");
      canvas.off("mouse:up");
    }
    var circle, isDown, origX, origY, circleDrawn;
    if (!drawnCircle) {
      setIsButtonSelected('circle');
      canvas.on("mouse:down", function (o) {
        arr_coords = [];
        if (canvas.getObjects().filter((obj) => obj.type === "circle").length > 0) {
          return;
        } else {
          isDown = true;
          var pointer = canvas.getPointer(o.e);
          origX = pointer.x;
          origY = pointer.y;
          circle = new fabric.Circle({
            left: pointer.x,
            top: pointer.y,
            radius: 10,
            strokeWidth: 2,
            fill: "transparent",
            stroke: "red",
            selectable: true,
            originX: "center",
            originY: "center",
            hasControls: true,
            hasRotatingPoint: false, // Disable rotating controls
            strokeUniform: true // Ensure stroke width remains constant
          });
          canvas.add(circle);
          // Hide rotating control
          circle.setControlVisible('mtr', false)
        }
      });

      if (!circleDrawn) {
        canvas.on("mouse:move", function (o) {
          if (!isDown) return;
          var pointer = canvas.getPointer(o.e);
          circle.set({ radius: Math.abs(origX - pointer.x) });
          canvas.renderAll();
        });

        if (isDown) return;
        canvas.on("mouse:up", function (o) {
          isDown = false;
          drawnCircle = true;
          let activeCircle = canvas.getActiveObject();
          let acoords = activeCircle?.aCoords;
          const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
          const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
          let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
          if (!acoords) return;
          circle.setCoords();// Update coordinates of the circle
          canvas.setActiveObject(circle); // Set the circle as the active object               
          canvas.renderAll();
          canvas.fire('object:modified', { target: circle });
          canvas.off("mouse:down");
          canvas.off("mouse:move");
          canvas.off("mouse:up");
          setSelectedIcon('');
          setIsButtonSelected('');
          return;
        });
      }
    }
  };

  // DRAW FREE HAND
  const handleDrawFreeHand = (active) => {
    setIsButtonSelected('FreeHand');
    setSelectedIcon(active);
    drawnRect = true;
    drawnCircle = true;
    canvas.off("mouse:down");
    canvas.off("mouse:move");
    canvas.off("mouse:up");
    if (canvas.isDrawingMode) {
      canvas.isDrawingMode = false;
      canvas.forEachObject(function (obj) {
        obj.set({
          selectable: false,
          evented: false
        });
      });
    } else {
      // Enable drawing mode
      canvas.isDrawingMode = true;
      canvas.freeDrawingBrush.width = 5;
      canvas.freeDrawingBrush.color = "#00aeff";
      canvas.on("mouse:down", function ({ e }) {
        isDrawing = true;
        arr_coords = [];
        onMouseDown(e);
      })
        .on("mouse:up", function ({ e }) {
          isDrawing = false;
          onMouseUp(e);
          setSelectedIcon('');
          canvas.getObjects().forEach(function (obj) {
            if (obj.type === 'path') {
              obj.set({
                selectable: false,
                evented: false,
                lockScalingX: true,
                lockScalingY: true,
                lockMovementX: true,
                lockMovementY: true,
                lockRotation: true
              });
            }
          });
          canvas.off("mouse:down");
          canvas.off("mouse:move");
          canvas.off("mouse:up");
          setIsButtonSelected('');
        })
        .on("mouse:move", function ({ e }) {
          if (isDrawing) {
            const pointer = canvas.getPointer(e);
            drawRealTime(e, pointer);
          }
        });
    }
  };

  // CLEAR ALL ANNOTATION
  const handleClearAnnotation = () => {
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    socketRef.current?.emit(CLEAR_SCREEN, webAssistantViewFlag, sessionIdRef.current);
    socketRef.current?.emit(REMOVE_TEXT, webAssistantViewFlag, sessionIdRef.current);
    canvas?.clear();
    setNotes('');
    setTakeNotes(false);
    setSelectedIcon('');
    arr_coords = [];
    setIsButtonSelected('');
    sessionStorage.setItem("userTyping", "false")
  };

  // SNAPSHOT DOWNLOAD HANDLER 
  const snapshotHandler = async () => {
    let canvas = document.querySelector("#canvas");
    let snapshot = document.querySelector("#snapshot_canvas");
    let ctxs = snapshot.getContext("2d");

    if (isConferenceCall) {
      if (!isWebAstJoin && !isRokidAstJoin)
        return toast.info(t('lbl_patientIsNotAvailable'));

      if (isMainView) {
        if (!isWebAstJoin && isRokidAstJoin) {
          return toast.info(t('lbl_patientIsNotAvailable'))
        } else if (isWebAstJoin && (!isRokidAstJoin || isRokidAstJoin)) {
          ctxs.drawImage(remoteVideoRef1.current, 0, 0, 920, 520);
        }
      } else {
        if (isRokidAstJoin && (isWebAstJoin || !isWebAstJoin)) {
          ctxs.drawImage(remoteVideoRef2.current, 0, 0, 920, 520);
        } else {
          return toast.info(t('lbl_smartGlassAssistantIsNotAvailable'));
        }
      }
    }
    else
      ctxs.drawImage(remoteVideoRef1.current, 0, 0, 920, 520);

    ctxs.drawImage(canvas, 0, 0, 920, 520);
    var dataURL = snapshot.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = "screenshot.png";
    link.click();
    toast.success(t('lbl_pictureHasTaken'))
  };

  // DELETE CANVAS OBJECT ON delete key
  window.onkeydown = deleteObject;
  function deleteObject(e) {
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    if (e.keyCode === 46) {
      let object = canvas.getActiveObject()?.get("type");
      socketRef.current?.emit(REMOVE_OBJECT, {
        type: object,
        sessionId: sessionIdRef.current,
        webAssistantViewFlag
      });
      arr_coords = [];
      canvas.remove(canvas.getActiveObject());
      return;
    }
    return;
  };

  const SendTextAnnotation = () => {
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    canvas.remove(canvasTxtRef.current);
    if (!isWebAssistant) {
      canvasTxtRef.current = new fabric.Textbox(notes, {
        left: canvas.width / 10,
        top: canvas.height / 1.2,
        width: (canvas.width / 1.25),
        fill: '#ffffff',
        fontSize: 20,
        splitByGrapheme: true
      });
      canvas.add(canvasTxtRef.current); const adjustCanvasScale = () => {
        const scaleFactor = Math.min(canvas.width / canvas.getWidth(), canvas.height / canvas.getHeight());
        canvas.setZoom(scaleFactor);
      };
      adjustCanvasScale();
    }
    setTimeout(() => {
      sessionStorage.setItem("userTyping", "false")
    }, 1000);

    socketRef.current?.emit(DRAW_TEXT, { notes: notes, sessionId: sessionIdRef.current, webAssistantViewFlag });
    if (notes && !isSend) {
      setIsSend(true);
      setNotes('');
    }
  }

  const cancelSendTextAnnotations = () => {
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    socketRef.current?.emit(REMOVE_TEXT, webAssistantViewFlag);
    canvas.remove(canvasTxtRef.current);
    setNotes('');
    setTakeNotes(false);
    setSelectedIcon('');
    sessionStorage.removeItem("userTyping");
    setTextAnnotationError(false);
    setTakeMessage(false);
  }

  const handleSendTextAnnotation = (isSend, notes) => {
    if (!notes || notes.trim() === '') return;
    if (isSend && notes) {
      cancelSendTextAnnotations()
    } else {
      SendTextAnnotation()
    }
  }

  // commented code for reference
  // const Send = () => (
  //   <IconButton disableRipple onClick={() => { handleSendTextAnnotation(isSend, notes); }} >
  //     {isSend && notes ? <CancelOutlinedIcon color='error' onClick={() => { handleSendTextAnnotation(isSend, notes) }} />
  //       : <SendOutlinedIcon color='primary' onClick={() => { handleSendTextAnnotation(isSend, notes) }} />}
  //   </IconButton >
  // );

  const Send = () => (
    <IconButton disableRipple onClick={() => handleSendTextAnnotation(isSend, notes)}>
      {isSend && notes ?
        <CancelOutlinedIcon color="error" /> :
        <SendOutlinedIcon color="primary" />
      }
    </IconButton>
  );

  // completed
  const zoomIn = () => {
    if (zoomLevel < 200 && zoomLevel >= 100) {
      zoomLevel += 20;
      let id = isMainView ? "video1" : "video3";
      const video = document.getElementById(id);
      canvas.zoomToPoint(
        new fabric.Point(canvas.width / 2, canvas.height / 2),
        zoomLevel / 100
      );
      video.style.transform = `scale(${zoomLevel / 100})`;
    }
  };

  // completed
  const zoomOut = () => {
    if (zoomLevel > 100 && zoomLevel <= 200) {
      zoomLevel -= 20;
      let id = isMainView ? "video1" : "video3";
      const video = document.getElementById(id);
      canvas.zoomToPoint(
        new fabric.Point(canvas.width / 2, canvas.height / 2),
        zoomLevel / 100
      );
      video.style.transform = `scale(${zoomLevel / 100})`;
    }
  };

  const handleStayInCall = () => {
    setUserLeftAlert(false);
    setNavigationBackPopup(false);
    setIsRemoteVideo(true);
    setRecordingPopup(false);
  }

  const inviteAssistant = () => {
    setInviteDialog(true);
  }

  const inviteRokidAssistant = () => {
    setRokidInviteDialog(true)
  }

  const handleMuteWhileRecording = () => {
    if (isConferenceCall) {
      if (!isMainView && recording && isWebAstJoin) {
        socketRef.current?.emit(WAST_MAIN_VIEW, sessionIdRef.current);
      } else if (isMainView && recording && isRokidAstJoin) {
        socketRef.current?.emit(ROKID_MAIN_VIEW, sessionIdRef.current);
      }
    }
  }

  const switchVideoContainers = async () => {
    // Stop and save recording when main view is swapped during active recording
    if (recording) {
      handleStopRecording();
    }
    setShowMuteIcon(!showMuteIcon);
    isRokidOnMainInConf = !isRokidOnMainInConf;
    const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
    const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
    let webAssistantViewFlag = (isWebAssistant && isConferenceCall) ? 1 : 0;
    const videoElement1 = remoteVideoRef1.current;
    const videoElement2 = remoteVideoRef2.current;
    if (videoElement1 || videoElement2) {
      const newContainer1 = container2;
      const newContainer2 = container1;
      const currentContainer1 = document.getElementById(container1);
      const currentContainer2 = document.getElementById(container2);
      if (currentContainer1 && currentContainer2) {
        currentContainer1.appendChild(videoElement2);
        currentContainer2.appendChild(videoElement1);
      }
      if (videoElement1) { //Show annotate btn if rokid joined only
        setShowAnnotateBtn(!showAnnotateBtn);
        setShowMuteIcon(!showMuteIcon)
      }
      setContainer1(newContainer1);
      setContainer2(newContainer2);
      setIsMainView(!isMainView);
    }
    const keyExists = sessionStorage.getItem('isWebAssistant') !== null;
    if (keyExists) {
      if (sessionStorage.getItem("isWebAssistant") === "true") {
        sessionStorage.setItem("isWebAssistant", JSON.stringify(false));
      } else {
        sessionStorage.setItem("isWebAssistant", JSON.stringify(true));
      }
    }
    else {
      sessionStorage.setItem("isWebAssistant", JSON.stringify(false));
    }

    handleMuteWhileRecording();
    recordMainView = (!recordMainView);
    // Subscribe/unsubscribe audio based on new main view (await for proper completion)
    await toggleMutedStates();
    canvas?.clear();
    setNotes('');
    setTakeNotes(false);
    setSelectedIcon('');
    setAnnotate(false);
    socketRef.current?.emit(CLEAR_SCREEN, webAssistantViewFlag, sessionIdRef.current);
    handleConsultantAudioTransmit();

    // Emit WAST/ROKID_MAIN_VIEW to mute the side-menu user's outgoing audio
    // and unmute the new main-view user's outgoing audio.
    // After the toggle above: isWebAssistant now reflects the NEW main view.
    const newIsWebAssistantOnMain = sessionStorage.getItem("isWebAssistant") === "true";
    const conferenceCallCheck = sessionStorage.getItem("isConferenceCall") === "true";
    if (conferenceCallCheck) {
      if (newIsWebAssistantOnMain) {
        // WAST is now on main â†’ unmute WAST mic, mute Glass mic
        socketRef.current?.emit(WAST_MAIN_VIEW, sessionIdRef.current);
      } else {
        // Rokid is now on main â†’ unmute Glass mic, mute WAST mic
        socketRef.current?.emit(ROKID_MAIN_VIEW, sessionIdRef.current);
      }
    }

    maintainAspectRatio();
    handleResizeCanvas();
    setTakeMessage(false);
  };

  useEffect(() => {
    const storedIsConferenceCall = sessionStorage.getItem('isConferenceCall');
    if (storedIsConferenceCall) {
      setIsConferenceCall(JSON.parse(storedIsConferenceCall));
    }
  }, []);

  // AGORA: Toggle audio playback for remote users based on who is on main view.
  // All tracks are always subscribed (done in user-published). This function only
  // controls stop()/play() to route which audio the consultant actually hears.
  // This avoids race conditions from subscribe/unsubscribe timing.
  async function toggleMutedStates() {
    if (!remoteUsers || !agoraClient) return;
    const isWebAssistantKey = sessionStorage.getItem('isWebAssistant');
    const isWebAssistantOnMain = isWebAssistantKey === "true";
    const isRokidOnMainView = isWebAssistantKey === "false";

    // Web assistant (UID=2): play audio if on main, stop if not
    try {
      const webAstUser = remoteUsers[AGORA_UID_WEBASSISTANT];
      if (webAstUser && webAstUser.audioTrack) {
        if (isWebAssistantOnMain) {
          webAstUser.audioTrack.play();
        } else {
          webAstUser.audioTrack.stop();
          logger.info("[Consultant] WAST audio: STOPPED (on side view)");
        }
      }
    } catch (error) {
      logger.error("Error toggling WAST audio playback:", error);
    }

    // Rokid (UID=3): play audio if on main, stop if not
    try {
      const rokidUser = remoteUsers[AGORA_UID_ROKID];
      if (rokidUser && rokidUser.audioTrack) {
        if (isRokidOnMainView) {
        rokidUser.audioTrack.play();
        } else {
        rokidUser.audioTrack.stop();
        }
      }
    } catch (error) {
      logger.error("Error toggling Rokid audio playback:", error);
    }
  }

  // by Deepika

  // setting up - outer container height , canvas dimensions on resize, and video parent container dimensions according device width by maintaining aspectRatio
  const outerContainerRef = useRef(null);
  const viewportHeightRef = useRef(document.documentElement.clientHeight);

  const initResizeOuterContainer = () => {
    setTimeout(() => {
      viewportHeightRef.current = document.documentElement.clientHeight;
      outerContainerRef.current.style.height = `${viewportHeightRef.current}px`;
      maintainAspectRatio();
      handleResizeCanvas();
    }, 10);
  };
  const handleResizeOuterContainer = () => {
    viewportHeightRef.current = document.documentElement.clientHeight;
    outerContainerRef.current.style.height = `${viewportHeightRef.current}px`;
    maintainAspectRatio();
    handleResizeCanvas();
  };
  useEffect(() => {
    initResizeOuterContainer();
    window.addEventListener('resize', handleResizeOuterContainer);
    return () => {
      window.removeEventListener('resize', handleResizeOuterContainer);
    };
  }, []);

  // by Deepika ENDs here

  //Emit the ON_OFF_AUDIO event to handle consultant audio based on which assistant is on the main view.
  const handleConsultantAudioTransmit = () => {
    const isWebAssistantKey = sessionStorage.getItem('isWebAssistant');
    const isWebassistantView = isWebAssistantKey === "true";
    const isRokidOnMainView = isWebAssistantKey === "false";
    const isWebAstJoin = (sessionStorage.getItem("isWebAssistantJoin") === "true") ?? false;
    const isRokidAstJoin = (sessionStorage.getItem("isRokidAstJoin") === "true") ?? false;
    // Use sessionStorage for conference flag to avoid stale React state in closures
    const isConfCallFlag = sessionStorage.getItem("isConferenceCall") === "true";

    // If isWebAssistant key doesn't exist, no one is on main view yet
    // (Rokid joined first but is in secondary view) - don't transmit audio
    if (isWebAssistantKey === null && !isWebAstJoin) {
      // Rokid is in secondary view, web assistant not joined - mute audio to Rokid
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag: 2 });
      return;
    }

    let webAssistantViewFlag = (isWebassistantView && isConfCallFlag) ? 1 : 0;

    if (isWebassistantView && isWebAstJoin) { // WAST(main view) & WAST join
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag });
     } else if (isRokidOnMainView && isWebAstJoin) { // Rokid on main & WAST joined (in secondary)
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag: 0 });
     } else if (isWebassistantView && isRokidAstJoin && !isWebAstJoin) { // WAST on main view but not joined & Rokid joined
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag });
     } else if (isRokidOnMainView && isRokidAstJoin && !isWebAstJoin) { // Rokid on main & only Rokid joined
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag: 0 });
     } else if (isWebassistantView && isRokidAstJoin && isWebAstJoin) { // WAST on main & both joined
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag });
     } else if (isRokidOnMainView && isRokidAstJoin && isWebAstJoin) { // Rokid on main & both joined
      socketRef.current?.emit(ON_OFF_AUDIO, { sessionId: sessionIdRef.current, webAssistantViewFlag: 0 });
     }
  }

  const dataConsumption = async (dataSent, isEndCall) => {

    const conferenceCallFlag = sessionStorage.getItem("isConferenceCall") === "true";
    const isWebAstJoinCheck = (sessionStorage.getItem("isWebAssistantJoin") === "true") ?? false;
    const isRokidAstJoinCheck = (sessionStorage.getItem("isRokidAstJoin") === "true") ?? false;
    const roleId = sessionStorage.getItem("role")
    const subscriptionId = sessionStorage.getItem("subscriptionId")

    const consultantIntervalData = dataSent - conIntervalDataSent;
    const webassistantIntervalData = wastDataReceived - wastIntervalDataSent;
    const rokidIntervalData = rokidDataReceived - rokidIntervalDataSent;

    let finalValue;
    if (isWebAstJoinCheck && isRokidAstJoinCheck) {
      finalValue = webassistantIntervalData + rokidIntervalData;
    } else if (isWebAstJoinCheck) {
      finalValue = webassistantIntervalData;
    } else if (isRokidAstJoinCheck) {
      finalValue = rokidIntervalData;
    } else {
      finalValue = 0;
    }

    if (!conferenceCallFlag) {
      finalValue = rokidIntervalData;
    }

    const params = {
      sessionId: sessionIdRef.current,
      subscriptionId: JSON.parse(subscriptionId),
      userId: user.userId,
      roleId: JSON.parse(roleId),
      dataSent: parseFloat(consultantIntervalData.toFixed(2)),
      dataReceived: parseFloat(finalValue.toFixed(2)),
      isConferenceCall: conferenceCallFlag,
      isEndCall
    };

    try {
      const resp = await apis.instance.post(`${SubscriptionDataUsage}`, params);
      if (resp.data.success) {
        conIntervalDataSent = dataSent;
        wastIntervalDataSent = wastDataReceived;
        rokidIntervalDataSent = rokidDataReceived;
        if (resp.data.data.remainingDataInPercentage <= process.env.REACT_APP_DATA_LIMIT) {
          setShowDataText(true);
          setRemainingDataPercentage(resp.data.data.remainingDataInPercentage);
          setDataExhausted(true);
        }
        if (resp.data.data.remainingData == 0) {
          sessionStorage.setItem("isRunning", JSON.stringify(false));
          handleEndCall();
        }
      } else {
        const errorMessage = resp.data.error ? t(resp.data.error) : t('responseMsg.failure');
        toast.error(errorMessage);
      }
    } catch (error) {
      const errorMessage = error.response && error.response.data && error.response.data.message ?
        t(error.response.data.message) :
        t('responseMsg.error');
      toast.error(errorMessage);
    }
  };

  const handleDataExhaustedPopup = () => {
    setShowDataExhausted(false);
    setDataExhausted(false);
  }
  
  const handleDelete = () => {
    setShowDataText(false);
  };
  return (
		<>
			<DataExhaustedDialog isOpen={showDataExhausted && dataExhausted} handleDataExhaustedPopup={handleDataExhaustedPopup} dataExhausted={dataExhausted} />

			{navigationBackPopup && (
				<Dialog
					open={navigationBackPopup}
					onClose={() => {
						return null;
					}}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description">
					<Box backgroundColor={"rgba(233, 57, 79, 0.2)"} color={"rgba(233, 57, 79, 1)"} padding={"8px 20px"}>
						<Typography variant="body2" fontWeight={"normal"}>
							<Typography display={"inline"} fontWeight={"bold"} variant="body2">
								Note:&nbsp;
							</Typography>
							{t("lbl_confirmLeaveCallWarning")}
						</Typography>
					</Box>
					<DialogTitle id="alert-dialog-title">{t("lbl_confirmation")}</DialogTitle>
					<DialogContent>{t("lbl_endCall")}</DialogContent>
					<DialogActions>
						<CadisButton variant="contained" color="error" onClick={handleEndCall}>
							{t("lbl_yes")}
						</CadisButton>
						<CadisButton variant="contained" color="success" onClick={handleStayInCall}>
							{t("lbl_no")}
						</CadisButton>
					</DialogActions>
				</Dialog>
			)}

			{userLeftAlert && (
				<CadisDialog
					open={userLeftAlert}
					title={`${state?.assistantName} left. You want to Stay in call ?`}
					DialogActions={
						<>
							<Button variant="contained" color="error" onClick={handleEndCall}>
								End Call
							</Button>
							<Button variant="contained" color="success" onClick={handleStayInCall}>
								Stay
							</Button>
						</>
					}
				/>
			)}
			{openInviteDialog()}
			{openReconnectDialog()}
			{openRokidUserInviteDialog()}
			<Box pl={2} pr={2} boxSizing="border-box" backgroundColor="#222222" className="consultant-call-screen" display="block" width="100vw" ref={outerContainerRef}>
				<Box display="flex" flexDirection="column" height="100%" width="100%" justifyContent={"center"} className="call_container" boxSizing="border-box">
					<>
						<Box sx={{ minHeight: "40px", height: "40px", display: "flex", alignItems: "center", color: "#ffffff" }}>
							<Grid container direction={"row"} spacing={0} border={"solid 0 yellow"} width={"100%"} height={"100%"} margin={"0"} alignItems={"center"}>
								<Grid item xs>
									<Box display={"flex"}>
										<Typography variant="h5" visibility={isRemoteVideo ? "visible" : "hidden"} sx={{ maxWidth: "calc( 96% - 20px)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
											{isMainView && isConferenceCall && isWebAstJoin && <>{t("lbl_patientView")}</>}
											{!isMainView && isConferenceCall && <>{t("lbl_smartGlassAssistantView")}</>}
											{!isConferenceCall && <>{state?.assistantName}</>}
										</Typography>
										{(isMuteRokid && showMuteIcon) || (isWebAsstMuted && !showMuteIcon) || (isMuteRokid && !isConferenceCall) ? <MicOffIcon color="error" sx={{ paddingLeft: 1 }} /> : null}
									</Box>
								</Grid>
								<Grid item xs={"auto"}>
									{/* Web assistant's entered name, centered at the top — only while the patient (web assistant) is on the main screen */}
									{isWebAstJoin && webAstName && isMainView ? (
										<Typography variant="h5" sx={{ maxWidth: "40vw", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
											{webAstName}
										</Typography>
									) : null}
									{!isRemoteVideo || failedPong > 2 ? <Typography>{t("lbl_connecting")}...</Typography> : null}
									{/* commented backup code */}
									{/* {showDataText &&
                    <Box color={'rgba(233, 57, 79, 1)'} padding={'2px 10px'}>
                      <Typography variant='body2' fontWeight={'normal'}>
                        {t('lbl_dataLimitOnly')} {remainingDataPercentage}% {t('lbl_dataLimitOnlyContinuousText')}
                      </Typography>
                    </Box>
                  } */}
								</Grid>
								<Grid item xs textAlign={"right"}>
									<Typography variant="h5" fontSize={"large"} component={"h6"} sx={{ color: "#F2AF4C" }}>
										{hours < 10 ? "0" + hours : hours}:{minutes < 10 ? "0" + minutes : minutes}:{seconds < 10 ? "0" + seconds : seconds}
									</Typography>
								</Grid>
							</Grid>
						</Box>
						<Box display={"flex"} justifyContent={"center"} position={"relative"} height={{ xs: "calc(100% - 142px)", sm: "calc(100% - 116px)", md: "calc(100% - 92px)" }}>
							<Grid container direction={"row"} spacing={1} border={"solid 0 yellow"} width={"100%"} height={"100%"} margin={"0"} flexWrap={"nowrap"}>
								<Grid item xs p={"0 !important"} display={"flex"} justifyContent={"center"} border={"solid 0 white"} maxWidth={isConferenceCall ? "calc(100% - 320px) !important" : "100%"}>
									<div className="video_container primary-video-container" ref={containerRef}>
										{showDataText && (
											<Box sx={{ position: "absolute", top: "5px", zIndex: "2" }}>
												<Chip label={`${t("lbl_dataLimitOnly")} ${remainingDataPercentage}% ${t("lbl_dataLimitOnlyContinuousText")}`} onDelete={handleDelete} color="info" size="medium" />
											</Box>
										)}
										{takeNotes && (
											<>
												{/* <Draggable defaultPosition={{ x: 0, y: 0 }} bounds="parent"> */}
												<div className="notes">
													<TextField
														onChange={(e) => {
															const spliceText = e.target.value.slice(0, 300);
															setNotes(spliceText);
															if (e.target.value.length > 300) {
																setTextAnnotationError(true);
																return;
															} else {
																setIsSend(false);
																setTextAnnotationError(false);
															}
														}}
														onBlur={() => {
															sessionStorage.setItem("userTyping", "true");
														}}
														onKeyDown={(e) => {
															if (e.target.value.length > 300) {
																setTextAnnotationError(true);
																return;
															} else {
																setTextAnnotationError(false);
																if (e.key === "Enter") {
                                  const textValue = e.target.value.trim();
                                  if (textValue === "") return; 
																	const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
																	const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
																	let webAssistantViewFlag = isWebAssistant && isConferenceCall ? 1 : 0;

																	canvas.remove(canvasTxtRef.current);
																	socketRef.current?.emit(DRAW_TEXT, { notes: e.target.value, webAssistantViewFlag });
																	canvasTxtRef.current = new fabric.Textbox(notes, {
																		left: canvas.width / 10,
																		top: canvas.height / 1.2,
																		width: canvas.width / 1.25,
																		fill: "#ffffff",
																		fontSize: 20,
																		splitByGrapheme: true,
																	});
																	canvas.add(canvasTxtRef.current);
																	const adjustCanvasScale = () => {
																		const scaleFactor = Math.min(canvas.width / canvas.getWidth(), canvas.height / canvas.getHeight());
																		canvas.setZoom(scaleFactor);
																	};
																	adjustCanvasScale();
																	if (notes && !isSend) setIsSend(true);
																	document.getElementById("messageInput").blur();
																	sessionStorage.setItem("userTyping", "textSend");
																	// setTakeNotes(false)
																	setTimeout(() => {
																		sessionStorage.setItem("userTyping", "false");
																	}, 1000);
																}
															}
														}}
														id="messageInput"
														size="small"
														name="username"
														type="text"
														value={notes}
														placeholder={`${t("lbl_writeNotesHere")}...`}
														autoComplete="off"
														InputProps={{ endAdornment: <Send /> }}
														error={textAnnotationError}
														helperText={textAnnotationError ? t("validation.msg_sendTextAnnotation") : ""}
														sx={{
															backgroundColor: "rgb(52, 52, 52, 0.3)",
															input: { color: "#ffffff" },
														}}
													/>
												</div>
												{/* </Draggable> */}
											</>
										)}
										{takeMessage && (
											<>
												<div className="notes">
													<TextField
														onChange={(e) => {
															const spliceText = e.target.value.slice(0, 70);
															setNotes(spliceText);
															if (e.target.value.length > 70) {
																setTextAnnotationError(true);
																return;
															} else {
																setIsSend(false);
																setTextAnnotationError(false);
															}
														}}
														onBlur={() => {
															sessionStorage.setItem("userTyping", "true");
														}}
														onKeyDown={(e) => {
                              const textValue = e.target.value.trim();
                              if (textValue === "") return; 
															if (e.target.value.length > 70) {
																setTextAnnotationError(true);
																return;
															} else {
																setTextAnnotationError(false);
																if (e.key === "Enter") {
																	const isWebAssistant = sessionStorage.getItem("isWebAssistant") === "true";
																	const isConferenceCall = sessionStorage.getItem("isConferenceCall") === "true";
																	let webAssistantViewFlag = isWebAssistant && isConferenceCall ? 1 : 0;

																	canvas.remove(canvasTxtRef.current);
																	socketRef.current?.emit(DRAW_TEXT, { notes: e.target.value, webAssistantViewFlag });
																	if (notes && !isSend) {
																		setIsSend(true);
																		setNotes("");
																	}
																	document.getElementById("messageInput").blur();
																	sessionStorage.setItem("userTyping", "textSend");
																	setTimeout(() => {
																		sessionStorage.setItem("userTyping", "false");
																	}, 1000);
																}
															}
														}}
														id="messageInput"
														size="small"
														name="username"
														type="text"
														value={notes}
														placeholder={`${t("lbl_writeNotesHere")}...`}
														autoComplete="off"
														InputProps={{ endAdornment: <Send /> }}
														error={textAnnotationError}
														helperText={textAnnotationError ? t("validation.msg_sendTextMessage") : ""}
														sx={{
															backgroundColor: "rgb(52, 52, 52, 0.4)",
															input: { color: "#ffffff" },
														}}
													/>
												</div>
											</>
										)}
										{/* COMMENTED: Agora manages audio playback internally
										<audio id="audio1" ref={remoteAudioRef1} muted={false} autoPlay={true} />
										<audio id="audio2" ref={remoteAudioRef2} muted={true} autoPlay={true} />
										*/}
										<div id="container1" className="primary-video" ref={innerContainerRef}>
											<video id="video1" ref={remoteVideoRef1} muted={false} playsInline autoPlay className="glass_video" onPlay={onPlayHandler} sx={{ border: "solid 0px blue", boxSizing: "border-box" }} />
											<canvas id="canvas" sx={{ position: "absolute", width: "1322px !important", height: "100%" }} />
											{/* Web assistant camera-off avatar — shown in the primary box when they are on main view */}
											{isWebAstCameraOff && isMainView ? (
												<Box
													sx={{
														position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
														display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
														gap: 1.5, zIndex: 3, pointerEvents: "none",
													}}>
													<Avatar sx={{ width: 96, height: 96, fontSize: "2.5rem", bgcolor: "#F2AF4C", color: "#222222" }}>
														{(webAstName || state?.assistantName) ? (webAstName || state.assistantName).trim().charAt(0).toUpperCase() : ""}
													</Avatar>
												</Box>
											) : null}
										</div>
									</div>
								</Grid>
								{isConferenceCall ? (
									<Grid item xs={"auto"} p={"0 !important"} width={"320px !important"} boxSizing={"border-box"} display={"flex"} justifyContent={"space-between"} alignItems={"flex-end"} flexDirection={"column"}>
										<Box sx={{ textAlign: "right" }}>
											{!isWAConferenceCallRef.current && (
												<Button id="InviteWebBtn" onClick={inviteAssistant} variant="contained" color={wastInviteSent ? "inherit" : "info"} sx={{ mb: 1, pointerEvents: wastInviteSent ? "none" : "auto" }}>
													{t("lbl_invitePeopleJoin")}
												</Button>
											)}
											<Button id="InviteRokidBtn" onClick={inviteRokidAssistant} variant="contained" color={rokidInviteSent ? "inherit" : "success"} sx={{ mb: 1, ml: 1, pointerEvents: rokidInviteSent ? "none" : "auto", textAlign: "left", display: "inline-block", maxWidth: "159px" }}>
												{t("lbl_inviteSmartGlassJoin")}
											</Button>
										</Box>
										<Box display={"flex"} flexDirection={"column-reverse"} overflow={"hidden auto"}>
											{/* self view box */}
											<Box sx={{ aspectRatio: "16/9", width: "300px", borderRadius: "10px", position: "relative", border: "solid 1px rgba(255,255,255,0.16)", margin: "7px 0 0 7px", boxSizing: "border-box" }} className="secondary-video-container">
												<div className="secondary-video">
													<video id="video2" ref={localVideoRef} muted={true} playsInline autoPlay width="100%" height="100%" className="local_video self-video" sx={{ borderRadius: "inherit", boxSizing: "border-box" }} />
												</div>
												{/* Consultant turned their own camera off — show an avatar over the self-view */}
												{isConsultantCameraOff ? (
													<Box
														sx={{
															position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
															display: "flex", alignItems: "center", justifyContent: "center",
															borderRadius: "inherit", zIndex: 4, pointerEvents: "none",
														}}>
														<Avatar sx={{ width: 56, height: 56, bgcolor: "#F2AF4C", color: "#222222" }}>
															<PersonIcon fontSize="large" />
														</Avatar>
													</Box>
												) : null}
												{/* Virtual background selector — bottom-left of the consultant self-view, colored for visibility. */}
												{isConferenceCall && (
													<Box sx={{ position: "absolute", bottom: "6px", left: "6px", zIndex: 5 }}>
														<Tooltip title={t("lbl_virtualBackground", "Virtual background")} placement="top-start" arrow>
															<IconButton
																aria-label="virtual-background"
																size="small"
																onClick={openBgDialog}
																sx={{ backgroundColor: virtualBg !== "none" ? "#2e7d32" : "#1976d2", color: "#fff", "&:hover": { backgroundColor: virtualBg !== "none" ? "#1b5e20" : "#115293" } }}
															>
																<WallpaperIcon fontSize="small" />
															</IconButton>
														</Tooltip>
													</Box>
												)}
											</Box>
											{/* secondary view - shufflable */}
											<Box sx={{ aspectRatio: "16/9", width: "300px", borderRadius: "10px", position: "relative", border: "solid 1px rgba(255,255,255,0.16)", margin: "7px 0 0 7px", boxSizing: "border-box", display: (isMainView && isRokidAstJoin) || (!isMainView && isWebAstJoin) ? "block" : "none" }} className="secondary-video-container">
												<Box backgroundColor="rgba(0,0,0,0.75)" sx={{ position: "absolute", top: 0, left: 0, right: 0 }} py={0.4} px={1}>
													<Typography variant="subtitle2" color={"white"} display={"flex"}>
														{!isMainView && t("lbl_patientViewBtn")}
														{isMainView && t("lbl_smartGlassViewBtn")}
														{(isMuteRokid && !showMuteIcon) || (isWebAsstMuted && showMuteIcon) ? <MicOffIcon color="error" sx={{ paddingLeft: 1 }} /> : null}
													</Typography>
												</Box>
												<div id="container2" className="secondary-video">
													<video id="video3" ref={remoteVideoRef2} muted={true} playsInline autoPlay className="local_video " onPlay={onPlayHandler} sx={{ borderRadius: "inherit", boxSizing: "border-box" }} />
												</div>
												{/* Web assistant camera-off avatar in the small screen when the patient has been shuffled off main */}
												{isWebAstCameraOff && isConferenceCall && !isMainView ? (
													<Box
														sx={{
															position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
															display: "flex", alignItems: "center", justifyContent: "center",
															borderRadius: "inherit", zIndex: 3, pointerEvents: "none",
														}}>
														<Avatar sx={{ width: 56, height: 56, fontSize: "1.5rem", bgcolor: "#F2AF4C", color: "#222222" }}>
															{(webAstName || state?.assistantName) ? (webAstName || state.assistantName).trim().charAt(0).toUpperCase() : ""}
														</Avatar>
													</Box>
												) : null}
												{/* shuffle view icon */}
												<Box sx={{ position: "absolute", bottom: "6px", right: "5px" }}>
													<Tooltip title={isMainView ? t("lbl_switchSmartGlass") : t("lbl_switchMainGlass")} placement="top-start" arrow>
														<IconButton aria-label="shuffle-video-icon" size="small" color={"inherit"} className="custom-default shuffle-video" disableRipple={true} onClick={switchVideoContainers}>
															<span className="cad-shuffle-video rotate-temp"></span>
														</IconButton>
													</Tooltip>
												</Box>
											</Box>
										</Box>
										{/* </div> */}
									</Grid>
								) : null}
							</Grid>
						</Box>
						{/* bottom grid here */}
						<Grid container alignItems="center" height={{ xs: "176px", sm: "92px", md: "50px" }}>
							<Grid item md={4.15} lg={4} xs={12} sm={6} order={{ xs: 2, md: 1 }}>
								<Stack direction="row" spacing={0.5}>
									{isMainView && isWebAstJoin && (
										<Stack direction="row" spacing={0.5}>
											<CadisButton
												size="small"
												sx={{ pointerEvents: isMainView && isWebAstJoin ? "auto" : "none", minWidth: "unset", paddingX: "6px" }}
												color={isMainView && isWebAstJoin ? "success" : "inherit"}
												variant="contained"
												onClick={() => {
													setTakeMessage(!takeMessage);
												}}>
												<TitleSharpIcon />
											</CadisButton>
										</Stack>
									)}

									{(!isMainView || isNormalCall) && (
										<CadisButton size="small" sx={{ pointerEvents: (showAnnotateBtn && isRokidAstJoin) || isNormalCall ? "auto" : "none" }} color={(showAnnotateBtn && isRokidAstJoin) || isNormalCall ? "info" : "inherit"} variant="contained" onClick={() => setAnnotate(!annotate)}>
											{annotate ? t("lbl_annotateOff") : t("lbl_annotate")}
										</CadisButton>
									)}

									{annotate && (
										<Stack direction="row" spacing={0.5}>
											<IconButton aria-label="circle" size="small" className={`${isButtonSelected === "circle" ? "active-annotation-child" : "custom-default-annotation"}`} disableRipple={true} onClick={() => handledrawCircle("circle")}>
												<CircleOutlinedIcon />
											</IconButton>

											<IconButton
												aria-label="sqaure"
												size="small"
												className={`${isButtonSelected === "rect" ? "active-annotation-child" : "custom-default-annotation"}`}
												color={isButtonSelected === "rect" ? "success" : "default"}
												disableRipple={true}
												onClick={() => {
													sessionStorage.setItem("userTyping", "false");
													drawRectangle("rect");
												}}>
												<CropSquareRoundedIcon />
											</IconButton>

											<IconButton
												aria-label="pencil"
												size="small"
												className={`${isButtonSelected === "FreeHand" ? "active-annotation-child" : "custom-default-annotation"}`}
												color={isButtonSelected === "FreeHand" ? "success" : "default"}
												disableRipple={true}
												onClick={() => {
													sessionStorage.setItem("userTyping", "false");
													handleDrawFreeHand("freehand");
												}}>
												<span className="cad-pen"></span>
											</IconButton>

											<IconButton
												aria-label="takeNoteIcon"
												size="small"
												className={`${selectedIcon === "text" ? "active-annotation-child" : "custom-default-annotation"}`}
												color="default"
												disableRipple={true}
												onClick={() => {
													setTakeNotes(!takeNotes);
													setIsButtonSelected("");
													setIsSend(false);
													sessionStorage.setItem("userTyping", "true");
													if (selectedIcon !== "text" && !takeNotes) setSelectedIcon("text");
													else setSelectedIcon("");
												}}>
												<TitleSharpIcon />
											</IconButton>

											<IconButton aria-label="clearAnotationIcon" size="small" color="error" disableRipple={true} onClick={handleClearAnnotation}>
												<CancelOutlinedIcon />
											</IconButton>
										</Stack>
									)}
								</Stack>
							</Grid>
							<Grid item md={5.2} lg={4} xs={12} order={{ xs: 1, md: 2 }}>
								<CadisButton size="small" variant="contained" color={!isConferenceCall ? "success" : (isMainView && isWebAstJoin) || (!isMainView && isRokidAstJoin) ? "success" : "inherit"} sx={{ pointerEvents: !isConferenceCall ? "auto" : (isMainView && isWebAstJoin) || (!isMainView && isRokidAstJoin) ? "auto" : "none" }} startIcon={<CenterFocusWeakIcon />} onClick={snapshotHandler}>
									Take a Picture
								</CadisButton>
								<Box display="inline-block" paddingX={1}>
									{isConferenceCall ? <ToggleComponent isVideo={true} socketRef={socketRef} setSelfVideoOff={setIsConsultantCameraOff} localAudioTrackAgora={localAudioTrackAgora} localVideoTrackAgora={localVideoTrackAgora} /> : ""} {/* Video toggle */}
									{/* Virtual background selector (conference-only, sits beside the camera icon) */}
										{isConferenceCall && (
											<>
												<Tooltip title={t("lbl_virtualBackground", "Virtual background")} arrow>
													<IconButton
														aria-label="virtual-background"
														size="small"
														className="custom-default"
														color={virtualBg !== "none" ? "info" : "default"}
														onClick={openBgDialog}
															sx={{ display: "none" }}
													>
														<WallpaperIcon />
													</IconButton>
												</Tooltip>
												<Dialog open={bgDialogOpen} onClose={() => { if (!applyingBg) setBgDialogOpen(false); }} maxWidth="md" fullWidth>
													<DialogTitle>{t("lbl_virtualBackground", "Virtual Background")}</DialogTitle>
													<DialogContent dividers>
														{/* --- Top controls: No background, Blur, Add Background --- */}
														<Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 1.5, alignItems: "start" }}>
															{VIRTUAL_BACKGROUNDS.map((bg) => renderBgTile(bg))}
															{/* Add Background tile (sits beside Blur) */}
															<Box onClick={uploadingBg ? undefined : handleAddBackgroundClick}
																sx={{ cursor: uploadingBg ? "default" : "pointer", gridColumn: "span 2", borderRadius: 1, overflow: "hidden", border: "2px dashed #9e9e9e" }}
															>
																<Box sx={{ width: "100%", aspectRatio: "16/9", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "text.secondary" }}>
																	<AddPhotoAlternateOutlinedIcon fontSize="small" />
																	<Typography variant="caption">{uploadingBg ? t("lbl_uploading", "Uploading...") : t("lbl_addBackground", "Add Background")}</Typography>
																</Box>
															</Box>
														</Box>

														{/* --- My backgrounds (user uploads) — only shown when the user has some --- */}
														{myBgs.length > 0 && (
															<>
																<Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>{t("lbl_myBackgrounds", "My Backgrounds")}</Typography>
																<Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 1.5, alignItems: "start", "&::after": { content: '""', gridColumn: "span 2" } }}>
																	{myBgs.map((b) => renderBgTile({ id: b.id, type: "img", src: b.imageUrl, label: b.name, deletable: true }))}
																</Box>
															</>
														)}

														{/* --- Default backgrounds (system images) --- */}
														<Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>{t("lbl_defaultBackgrounds", "Default Backgrounds")}</Typography>
														<Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 1.5, alignItems: "start", "&::after": { content: '""', gridColumn: "span 2" } }}>
															{defaultBgs.map((b) => renderBgTile({ id: b.id, type: "img", src: b.imageUrl, label: b.name }))}
														</Box>

														{/* Hidden file input driving the upload flow */}
														<input
															ref={bgFileInputRef}
															type="file"
															accept="image/png,image/jpeg,image/webp"
															style={{ display: "none" }}
															onChange={handleBgFileSelected}
														/>
													</DialogContent>
													<DialogActions>
														<Button onClick={() => setBgDialogOpen(false)} disabled={applyingBg}>{t("lbl_cancel", "Cancel")}</Button>
														<Button variant="contained" onClick={handleApplyVirtualBg} disabled={applyingBg}>
															{applyingBg ? t("lbl_applying", "Applying...") : t("lbl_apply", "Apply")}
														</Button>
													</DialogActions>
												</Dialog>
											</>
										)}
										<ToggleComponent isVideo={false} socketRef={socketRef} localAudioTrackAgora={localAudioTrackAgora} localVideoTrackAgora={localVideoTrackAgora} /> {/* Audio toggle */}
								</Box>
								<Box sx={{ position: "relative", display: "inline-block" }}>
									<CadisButton
										size="small"
										variant="contained"
										color={!isConferenceCall ? (recording ? "error" : "success") : (isMainView && isWebAstJoin) || (!isMainView && isRokidAstJoin) ? (recording ? "error" : "success") : "inherit"}
										sx={{
											pointerEvents: !isConferenceCall ? "auto" : (isMainView && isWebAstJoin) || (!isMainView && isRokidAstJoin) ? "auto" : "none",
										}}
										startIcon={recording ? <StopIcon /> : <FiberManualRecordIcon size={"small"} sx={{ color: !isConferenceCall ? "error.main" : (isMainView && isWebAstJoin) || (!isMainView && isRokidAstJoin) ? "error.main" : "grey.dark" }} />}
										onClick={recording ? handleStopRecording : handleStartRecording}>
										{recording ? t("lbl_stopRecording") : t("lbl_recordSession")}
									</CadisButton>
									{recording && (
										<Box display={"flex"} alignItems={"center"} position="absolute" left={"calc(100% + 5px)"} top={"3px"} className="recording-started-border" paddingX={0.6} paddingY={0} lineHeight="0">
											<Box component={"span"} sx={{ color: "error.main" }}>
												<FiberManualRecordIcon />
											</Box>
											<Box component={"span"}>
												<Typography color="#ffffff">{t("lbl_rec")}</Typography>
											</Box>
										</Box>
									)}
								</Box>
							</Grid>
							<Grid item md={2.65} lg={4} xs={12} sm={6} order={{ xs: 3, md: 3 }} display="flex" justifyContent="space-between" alignItems="center">
								<Box display="inline-block">
									<div className="zoom_icons">
										<ZoomOutOutlinedIcon fontSize={"large"} sx={{ cursor: "pointer" }} onClick={zoomOut} />
										<Box sx={{ borderRadius: 2, border: "1px solid #fff", paddingY: "1px", paddingX: "2px", marginX: "6px", minWidth: "36px", textAlign: "center" }}>
											<Typography fontWeight="bold">{(zoomLevel / 100) * 100 - 100}%</Typography>
										</Box>
										<ZoomInOutlinedIcon fontSize={"large"} sx={{ cursor: "pointer" }} onClick={zoomIn} />
									</div>
								</Box>
								<CadisButton size="small" variant="contained" color="error" onClick={handleEndCall} sx={{ alignSelf: "center" }}>
									{t("lbl_endCallBtn")}
								</CadisButton>
							</Grid>
						</Grid>
					</>
					<canvas id="snapshot_canvas" width={920} height={520} style={{ display: "none" }}></canvas>
					<canvas id="recording_canvas" width={920} height={520} style={{ display: "none" }}></canvas>
				</Box>
			</Box>
		</>
	);
};

export default CallScreen;
